// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { FaInfo, FaUpload, FaSearch, FaCog, FaPlus, FaFileImport, FaFileExport, FaSync, FaFileUpload, FaCommentDots, FaQuestionCircle, FaFileAlt, FaPrint, FaCopy, FaFileExcel, FaFileCsv } from "react-icons/fa";
// import { FaFileImage, FaFilePdf } from "react-icons/fa";
// import { FiPrinter, FiMoreVertical } from "react-icons/fi";
// import * as XLSX from 'xlsx';
// import "jspdf-autotable";
// import { useNavigate } from "react-router-dom";
// import { jsPDF } from "jspdf";
// import AddTask from "./AddTask";
// import axios from "axios";
// import AssignTask from "./AssignTask";
// import { MdOutlineAccountTree } from "react-icons/md";
// import useOutsideClick from "../../Hooks/useClickOutside";
// import { useSocket } from '../../context/SocketContext'
// import { useLoggedInUser } from "../../context/LoggedUser";
// import CommentModal from "./Comments";
// import { useNotification } from '../../context/NotificationContext'
// import { useRole } from "../../context/RoleContext";
// import { usePermissions } from "../../context/PermissionContext";
// import Loading from "../../components/Loading";
// import { toast } from "react-toastify";
// import { useLocation } from "react-router-dom";

// const AllTasks = () => {
//   const navigate = useNavigate();
//   const { role } = useRole();

//   const [entries, setEntries] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [taskData, setTaskData] = useState([]); 
//   const [isLoading, setIsLoading] = useState(false);
//   const [isExporting, setIsExporting] = useState(false); 
//   const [searchTaskQuery, setSearchTaskQuery] = useState("");

//   const [isHoldModalOpen, setIsHoldModalOpen] = useState(false);
//   const [holdReason, setHoldReason] = useState("");

//   const [showExportOptions, setShowExportOptions] = useState(false);
//   const [filter, setFilter] = useState("All");
//   const [file, setFile] = useState(null);
//   const [taskStatus, setTaskStatus] = useState("");
//   const [uploadError, setUploadError] = useState(null);
//   const [isUploading, setIsUploading] = useState(false);
//   const [showDropDown, setShowDropDown] = useState(false)
//   const [isAddTaskModalOpen, setIsAddTaskModalOpen] = useState(false);
//   const [solution, setSolution] = useState(null);
//   const [brief, setBrief] = useState(null);
//   const [isAssinTaskModalOpen, setIsAssinTaskModalOpen] = useState(false);
//   const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
//   const [isDropDownOpen, setIsDropDownOpen] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [showSettings, setShowSettings] = useState(false);
//   const [editingTask, setEditingTask] = useState(null);
//   const [isTaskLogsVisible, setIsTaskLogsVisible] = useState(false);
//   const [isUploadPageVisible, setIsUploadPageVisible] = useState(false);
//   const [isUploadBriefVisible, setIsUploadBriefVisible] = useState(false);
//   const [names, setNames] = useState({});
//   const [isExtensionModalOpen, setIsExtensionModalOpen] = useState(false);
//   const [extensionReason, setExtensionReason] = useState("");
//   const [newSoftDeadline, setNewSoftDeadline] = useState("");
//   const [newHardDeadline, setNewHardDeadline] = useState("");
//   const [commentType, setCommentType] = useState("");
//   const { permissions } = usePermissions();
//   const { loggedInUser } = useLoggedInUser();
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const { createNotification } = useNotification();
//   const location = useLocation();
//   const [employees, setEmployees] = useState([]);

//   useEffect(() => {
//     if (location.state?.title) {
//       setSearchTaskQuery(location.state.title);

//     }
//   }, [location.state]);

//   const printRef = useRef();
//   const { socket } = useSocket()
//   const closeRef = useRef();
//   const dropdownRef = useRef();
//   const exportRef = useRef();
//   useOutsideClick(closeRef, () => setShowSettings(false));
//   useOutsideClick(dropdownRef, () => setIsDropDownOpen(false));
//   useOutsideClick(exportRef, () => setShowExportOptions(false));
//   const dropDownMenuRef = useRef();
//   useOutsideClick(dropDownMenuRef, () => setShowDropDown(false));

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropDown(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);



//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const response = await axios.get(`${apiUrl}/api/team/get-team`, {
//           withCredentials: true,
//         });

//         if (response.data.success) {
//           setEmployees(response.data.team);
//         }
//       } catch (error) {
//         console.error("Error fetching employees:", error);
//       }
//     };

//     fetchEmployees();
//   }, []);


//   const allowedTypes = [
//     // 📷 Images
//     "image/jpeg",
//     "image/png",
//     "image/jpg",
//     "image/gif",
//     "image/webp",
//     "image/bmp",
//     "image/svg+xml",
//     "image/tiff",
//     "image/x-icon", // .ico

//     // 📄 PDF
//     "application/pdf",
//     "text/plain", // .txt, .log, .env
//     "application/json",
//     "application/xml",
//     "text/xml",

//     // 🎞️ Video
//     "video/mp4",
//     "video/x-msvideo", // .avi
//     "video/x-matroska", // .mkv
//     "video/webm",
//     "video/ogg",
//     "video/3gpp", // .3gp
//     "video/quicktime", // .mov
//     "video/x-flv", // .flv
//     "video/mpeg", // .mpeg

//     // 🔊 Audio
//     "audio/mpeg", // .mp3
//     "audio/wav",
//     "audio/mp4",
//     "audio/x-ms-wma",
//     "audio/ogg",
//     "audio/webm",
//     "audio/x-flac",
//     "audio/aac",
//     "audio/midi",

//     // 🧾 Microsoft Word
//     "application/msword", // .doc
//     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
//     "application/vnd.ms-word.document.macroEnabled.12", // .docm

//     // 📊 Microsoft Excel (Old + New)
//     "application/vnd.ms-excel", // .xls
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
//     "application/vnd.ms-excel.sheet.macroEnabled.12", // .xlsm

//     // 📽️ Microsoft PowerPoint (Old + New)
//     "application/vnd.ms-powerpoint", // .ppt
//     "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
//     "application/vnd.ms-powerpoint.presentation.macroEnabled.12", // .pptm

//     // 📅 MS Project / Outlook / Visio
//     "application/vnd.ms-project", // .mpp
//     "application/vnd.ms-outlook", // .msg
//     "application/vnd.visio", // .vsd, .vsdx

//     // 📈 Tableau & Power BI (fallback MIME)
//     "application/octet-stream", // .pbix, .twb, .twbx
//     "application/x-tableau", // optional for some Tableau configs
//     "text/x-r-markdown", // .rmd

//     // 🗜️ Archives
//     "application/zip",
//     "application/x-zip-compressed",
//     "application/x-rar-compressed",
//     "application/x-compressed",
//     "multipart/x-zip",

//     "application/x-7z-compressed",
//     "application/x-tar",
//     "application/gzip",
//     "application/x-bzip",
//     "application/x-bzip2",
//     "application/x-compressed",
//     "application/x-xz",

//     // 👨‍💻 Programming / Scripting / Source Code
//     "text/plain", // .txt, .env, etc.
//     "text/x-python", // .py
//     "text/x-java-source", // .java
//     "text/x-csrc", // .c
//     "text/x-c++src", // .cpp
//     "text/javascript", // .js
//     "application/x-typescript", // .ts
//     "application/x-httpd-php", // .php
//     "application/x-sh", // .sh
//     "application/x-bash", // .bash
//     "application/sql", // .sql
//     "application/x-java-archive", // .jar
//     "application/x-msdownload", // .exe
//     "application/x-powershell", // .ps1
//     "application/x-r", // .r
//     "application/x-csh", // .csh
//     "text/x-script.perl", // .pl
//     "text/x-ruby", // .rb
//     "application/x-lua", // .lua
//     "text/x-go", // .go
//     "text/x-kotlin", // .kt
//     "text/x-swift", // .swift
//     "text/x-scala", // .scala
//     "text/x-typescript", // .ts
//     "application/x-dart", // .dart
//     "application/x-vbscript", // .vbs

//     // 📝 Dev Config / Markup / Data
//     "text/html",
//     "text/css",
//     "application/json",
//     "application/xml",
//     "text/csv",
//     "text/tsv",
//     "application/x-yaml", // .yaml
//     "application/x-toml", // .toml
//     "application/x-ini", // .ini
//     "text/markdown", // .md
//     "application/x-markdown", // .md

//     ///
//     "text/x-r-markdown",            // .Rmd files
//     "text/plain",                   // fallback for .Rmd
//     "application/vnd.tableau.twbx", // Tableau TWBX files
//     "application/octet-stream",

//     // ⚠️ Fallback
//     "application/octet-stream", // any unknown but allowed binaries
//   ];
//   const validExtensions = [".rmd", ".twbx", ".pbix", '.pbix', '.twb', '.twbx', '.rmd',
//     '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
//     '.pdf', '.zip', '.rar', '.7z',
//     '.js', '.ts', '.py', '.java', '.cpp', '.c',
//     '.html', '.css', '.json', '.xml', '.csv', '.txt'];

//   const fetchNameWithId = useCallback(async (userId) => {
//     if (!userId) return null;
//     try {
//       const response = await axios.get(`${apiUrl}/api/fetchUser/${userId}`, { withCredentials: true });
//       return response.data.name;
//     } catch (error) {
//       console.error(`Error fetching user name for ID ${userId}:`, error);
//       return "N/A";
//     }
//   }, [apiUrl]);

//   const fetchTaskData = useCallback(async () => {
//     setIsLoading(true);
//     try {
//       const params = {
//         page: currentPage,
//         limit: entries,
//         status: filter,
//         search: searchTaskQuery,
//       };
//       const response = await axios.get(`${apiUrl}/api/task/get-task`, { params, withCredentials: true });
//       setTaskData(response.data.tasks);
//       setTotalPages(response.data.totalPages || 1);
//     } catch (error) {
//       console.error("Error fetching tasks:", error);
//       toast.error("Failed to fetch tasks.");
//       setTaskData([]);
//       setTotalPages(1);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [apiUrl, currentPage, entries, filter, searchTaskQuery]);

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       fetchTaskData();
//     }, 500); // 500ms delay after user stops typing
//     return () => clearTimeout(handler);
//   }, [searchTaskQuery, filter, currentPage, entries, fetchTaskData]);

//   const statusColors = { Delayed: "bg-red-50 text-red-800", Unassigned: "bg-orange-50 text-orange-900", "Assigned to": "bg-blue-50 text-blue-900", Running: "bg-green-50 text-green-900", "Approved By": "bg-purple-50 text-purple-900", "Quality Check": "bg-yellow-50 text-yellow-900", "Quality Check done by": "bg-gray-50 text-gray-900", Completed: "bg-teal-50 text-teal-900", Delivered: "bg-indigo-50 text-indigo-900", 'On Hold': 'bg-yellow-100 text-yellow-800', 'Cancelled': 'bg-gray-200 text-gray-800' };

//   const handleReload = useCallback(() => fetchTaskData(), [fetchTaskData]);

//   const closeAddTaskModal = () => setIsAddTaskModalOpen(false);
//   const closeAssignTaskModal = () => setIsAssinTaskModalOpen(false);

//   const handleTaskClick = useCallback((task) => {
//     setSelectedTask(task);
//     setIsTaskLogsVisible(false);
//     setIsUploadPageVisible(false);
//     setIsUploadBriefVisible(false);
//     setIsCommentModalOpen(false);
//   }, []);


//   const handleToggleDropdown = () => { setIsDropDownOpen(!isDropDownOpen); };

//   const fetchSolution = async (taskId) => {
//     try {
//       const response = await axios.get(
//         `${apiUrl}/api/task/get-solution/${taskId}`,
//         { withCredentials: true }
//       );
//       setSolution(response.data.solutions);
//     } catch (error) { }
//     finally {
//       // setLoading(false);
//     }
//   };

//   const handleApplyExtension = async () => {

//     if (!newSoftDeadline || !newHardDeadline || !extensionReason) {
//       toast.error("Please fill all fields for the extension request.");
//       return;
//     }
//     if (new Date(newHardDeadline) < new Date(newSoftDeadline)) {
//       toast.error("Hard Deadline cannot be earlier than Soft Deadline.");
//       return;
//     }

//     let managerId = null;
//     if (selectedTask && selectedTask.iterations && selectedTask.iterations.length > 0) {
//       const lastIteration = selectedTask.iterations[selectedTask.iterations.length - 1];
//       managerId = lastIteration.assigned_by;
//     }

//     if (!managerId) {
//       toast.error("Cannot request extension: The task has no assignment history.");

//       return;
//     }


//     const payload = {
//       new_soft_deadline: newSoftDeadline,
//       new_hard_deadline: newHardDeadline,
//       reason: extensionReason,
//     };

//     try {
//       const response = await axios.post(
//         `${apiUrl}/api/task/${selectedTask._id}/request-extension`,
//         payload,
//         { withCredentials: true }
//       );

//       const updatedTask = response.data.task;

//       if (!updatedTask) {
//         console.error("ERROR: The server response did not include 'task' object.");
//         toast.error("Request submitted, but failed to get task update from server.");
//         return;
//       }

//       const notificationMessage = `${loggedInUser.name} has requested an extension for task '${updatedTask.title}' which you assigned.`;

//       socket.emit("send-notification", {
//         to: managerId,
//         message: notificationMessage,
//         notDesc: updatedTask.taskId,
//         sender: loggedInUser
//       });

//       await createNotification({
//         sender: loggedInUser._id,
//         receiver: [managerId],
//         message: notificationMessage,
//         notDesc: updatedTask.taskId,
//       });

//       toast.success("Extension request submitted successfully!");

//       setTaskData((prev) =>
//         prev.map((task) => (task._id === selectedTask._id ? updatedTask : task))
//       );
//       setIsExtensionModalOpen(false);

//     } catch (err) {
//       if (err.response) {
//         toast.error(err.response.data.message || "An error occurred on the server.");
//       } else {
//         toast.error("Could not connect to the server. Please check your connection.");
//       }
//     }
//   };
//   const handleCancelTask = async () => {
//     if (!selectedTask) return;
//     try {
//       const response = await axios.post(
//         `${apiUrl}/api/task/cancel/${selectedTask._id}`,
//         {},
//         { withCredentials: true }
//       );
//       toast.success("Task cancelled successfully!");
//       fetchTaskData(); // Refresh task list
//       setSelectedTask(response.data.task); // Update local selected task
//     } catch (error) {
//       console.error("Cancel task error:", error);
//       toast.error(error?.response?.data?.message || "Failed to cancel task.");
//     }
//   };
//   const handleHoldTask = async () => {
//     if (!holdReason.trim()) return toast.warn("Please enter a reason.");
//     try {
//       const response = await axios.post(
//         `${apiUrl}/api/task/hold/${selectedTask._id}`,
//         { reason: holdReason },
//         { withCredentials: true }
//       );
//       toast.success("Task put on hold successfully!");
//       fetchTaskData(); // Refresh task list
//       setSelectedTask(response.data.task);
//       setIsHoldModalOpen(false);
//       setHoldReason("");
//     } catch (error) {
//       console.error("Hold task error:", error);
//       toast.error(error?.response?.data?.message || "Failed to hold task.");
//     }
//   };

//   const handleResumeTask = async () => {
//     if (!selectedTask) return;
//     try {
//       const response = await axios.post(
//         `${apiUrl}/api/task/resume/${selectedTask._id}`,
//         {}, // No payload needed
//         { withCredentials: true }
//       );
//       toast.success("Task resumed successfully!");
//       fetchTaskData(); // Refresh the list of tasks
//       setSelectedTask(response.data.task); // Update the currently selected task view
//     } catch (error) {
//       console.error("Resume task error:", error);
//       toast.error(error?.response?.data?.message || "Failed to resume task.");
//     }
//   };


//   const fetchBrief = async (taskId) => {
//     try {
//       // setLoading(true);
//       const response = await axios.get(
//         `${apiUrl}/api/task/get-brief/${taskId}`,
//         { withCredentials: true }
//       );
//       setBrief(response.data.briefs);
//     } catch (error) {
//       console.error("Error fetching brief:", error);
//     } finally {
//       // setLoading(false);
//     }
//   };

//   useEffect(() => { if (selectedTask) { fetchSolution(selectedTask._id); fetchBrief(selectedTask._id); } }, [selectedTask]);

//   const handleDelete = async (taskId) => {
//     setIsLoading(true);
//     try {
//       await axios.delete(`${apiUrl}/api/task/delete-task/${taskId}`, {
//         withCredentials: true,
//       });
//       setTaskData((prev) => prev.filter((task) => task._id !== taskId));
//       if (selectedTask?._id === taskId || editingTask?._id === taskId) {
//         setSelectedTask(null);
//       }
//       toast.success("Task deleted successfully!");
//     } catch (error) {
//       console.error("Error deleting task:", error);
//       toast.error("Failed to delete task. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleStatusChange = async (status) => {
//     try {
//       let endpoint =
//         status === "Completed"
//           ? `${apiUrl}/api/task/complete-task`
//           : `${apiUrl}/api/task/deliver-task`;

//       const response = await axios.put(
//         endpoint,
//         { taskId: selectedTask._id, employeeId: loggedInUser._id },
//         { withCredentials: true }
//       );



//       // Ensure we are comparing with strict equality
//       if (response.status === 200 && response.data.task.status === "Delivered") {
//         const employees = response.data.task.iterations;

//         if (employees.length > 0) {
//           // Emit event to each assigned employee
//           employees.forEach(employee => {
//             socket.emit("deliver-task", {
//               to: employee.assigned_to,
//               message: `Task Delivered ${response.data.task.taskId}`,
//               date: new Date(),
//               notDesc: response.data.task.taskId,
//             });
//           });

//           // Create notifications for assigned employees
//           await createNotification({
//             sender: loggedInUser._id,
//             receiver: employees.map(employee => employee.assigned_to),
//             message: "Task Delivered",
//             notDesc: response.data.task.taskId,
//           });


//         } else {
//           console.warn("No employees assigned for notification");
//         }
//       }

//       if (response.status === 200 && response.data.task.status === "Completed") {
//         const employees = response.data.task.iterations;

//         if (employees.length > 0) {
//           // Emit event to each assigned employee
//           employees.forEach(employee => {

//             socket.emit("complete-task", {
//               to: employee.assigned_to,
//               message: `Task completed ${response.data.task.taskId}`,
//               date: new Date(),
//               notDesc: response.data.task.taskId,
//             });
//           });

//           // Create notifications for assigned employees
//           await createNotification({
//             sender: loggedInUser._id,
//             receiver: employees.map(employee => employee.assigned_to),
//             message: "Task Completed",
//             notDesc: response.data.task.taskId,
//           });

//           // console.log("Notification created successfully");
//         } else {
//           console.warn("No employees assigned for notification");
//         }
//       }

//       // Update the local task status
//       setTaskStatus(status);
//       setTaskData((prevTasks) =>
//         prevTasks.map((task) =>
//           task._id === selectedTask._id ? { ...task, status } : task
//         )
//       );
//     } catch (error) {
//       console.error("Error updating task status:", error);
//     }
//   };

//   const handleOpenTaskLogs = () => {
//     setIsTaskLogsVisible(true);
//     setIsUploadPageVisible(false);
//     setIsUploadBriefVisible(false);
//     setIsCommentModalOpen(false);

//   };

//   const handleCloseTaskLogs = () => { setIsTaskLogsVisible(false); };
//   const handleCompleteTask = () => {
//     handleStatusChange("Completed");
//     fetchTaskData();
//   };

//   const handleDeliverTask = () => {
//     handleStatusChange("Delivered");
//   };

//   const openTaskModal = (task) => {
//     setIsAddTaskModalOpen(true); // Open the task modal
//     setEditingTask(task); // Set the selected task for editing
//   };

//   const handleUpload = () => {
//     setIsUploadPageVisible(true);
//     setIsTaskLogsVisible(false);
//     setIsUploadBriefVisible(false);
//     setIsCommentModalOpen(false);
//   };

//   const handleCommentModal = (type = "comment") => {
//     setCommentType(type);
//     setIsUploadPageVisible(false);
//     setIsTaskLogsVisible(false);
//     setIsUploadBriefVisible(false);
//     setIsCommentModalOpen(true);
//   }
//   const handleCloseUploadPage = () => {
//     setIsUploadPageVisible(false);
//     setIsUploadBriefVisible(false);
//   };


//   const handleFileChange = (event) => {
//   const selectedFiles = Array.from(event.target.files);

//   const invalidFiles = selectedFiles.filter((file) => {
//     const fileName = file.name.toLowerCase();
//     const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));
//     return !(allowedTypes.includes(file.type) || hasValidExtension);
//   });

//   if (invalidFiles.length > 0) {
//     setUploadError("One or more files are invalid.");
//     return;
//   }

//   setFile(selectedFiles); 
//   setUploadError(null);
// };

//  const handleSubmit = async () => {
//   if (!file || file.length === 0) {
//     toast.warn('Please select at least one file before submitting.');
//     return;
//   }

//   setIsUploading(true);
//   setUploadError(null);
//   const formData = new FormData();
//   file.forEach((f) => formData.append("file", f)); 
//   formData.append("taskId", selectedTask._id);

//   try {
//     const response = await axios.post(
//       `${apiUrl}/api/task/add-solution/${selectedTask._id}`,
//       formData,
//       { withCredentials: true }
//     );
//     toast.success("Files uploaded successfully!");
//     setFile(null);
//     setSolution(response.data.solutions);
//     fetchSolution(selectedTask._id);
//   } catch (error) {
//     console.error("Upload error:", error);
//     setUploadError("Failed to upload files. Please try again.");
//   } finally {
//     setIsUploading(false);
//   }
// };



//   const handleUploadBrief = () => {
//     setIsUploadBriefVisible(true); // Make the upload brief section visible
//     setIsUploadPageVisible(false); // Hide the main upload page
//     setIsTaskLogsVisible(false); // Hide the task logs section
//   };


//   const handleBriefSubmit = async () => {
//   if (!file || file.length === 0) {
//     toast.warn("Please select at least one file before submitting.");
//     return;
//   }

//   setIsUploading(true);
//   setUploadError(null);
//   const formData = new FormData();
//   file.forEach((f) => formData.append("file", f)); // ✅ multiple files
//   formData.append("taskId", selectedTask._id);

//   try {
//     const response = await axios.post(
//       `${apiUrl}/api/task/add-brief/${selectedTask._id}`,
//       formData,
//       { withCredentials: true }
//     );
//     fetchBrief(selectedTask._id);
//     toast.success('Brief uploaded successfully!');
//     setFile(null);
//   } catch (error) {
//     console.error("Upload error:", error);
//     setUploadError("Failed to upload brief. Please try again.");
//   } finally {
//     setIsUploading(false);
//   }
// };


//   useEffect(() => {
//     if (!selectedTask || !selectedTask.iterations) return;

//     const fetchNames = async () => {
//       const fetchedNames = {}; // Object to store fetched names.

//       const promises = selectedTask.iterations.map(async (log) => {
//         if (log.assigned_by && !fetchedNames[log.assigned_by]) {
//           fetchedNames[log.assigned_by] = await fetchNameWithId(
//             log.assigned_by
//           );
//         }
//         if (log.assigned_to && !fetchedNames[log.assigned_to]) {
//           fetchedNames[log.assigned_to] = await fetchNameWithId(
//             log.assigned_to
//           );
//         }
//       });

//       await Promise.all(promises); // Ensure all names are fetched before proceeding.
//       setNames(fetchedNames); // Update state with the fetched names.
//     };

//     fetchNames();
//   }, [selectedTask, fetchNameWithId]);


//   const handlePrint = () => {
//     if (printRef.current) {
//       const clonedContent = printRef.current.cloneNode(true);

//       clonedContent
//         .querySelectorAll("button, svg")
//         .forEach((el) => el.remove());


//       if (isTaskLogsVisible) {
//         // If only task logs should be printed, extract relevant data.
//         const taskLogs = selectedTask?.iterations?.map(
//           (log, index) =>
//             `${index + 1}. ${log.assigned_by} assigned to ${log.assigned_to
//             } - ${log.status}`
//         ) || ["No logs available."];


//         // Open a new print window and display formatted task logs.
//         const printWindow = window.open("", "", "width=800,height=600");
//         printWindow.document.write(`
//           <html>
//             <head>
//               <title>Task Logs</title>
//               <style>
//                 body { font-family: Arial, sans-serif; padding: 20px; color: #333; }
//                 .container { width: 100%; max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ddd; border-radius: 10px; }
//                 h2 { text-align: center; font-size: 22px; color: #007BFF; }
//                 .logs { margin-top: 20px; padding: 10px; background: #f9f9f9; border-radius: 5px; }
//               </style>
//             </head>
//             <body>
//               <div class="container">
//                 <h2>📜 Task Logs</h2>
//                 <div class="logs">
//                   <ul>
//                     ${taskLogs.map((log) => `<li>${log}</li>`).join("")}
//                   </ul>
//                 </div>
//               </div>
//             </body>
//           </html>
//         `);

//         printWindow.document.close();
//         printWindow.onload = () => {
//           printWindow.print();
//           printWindow.close();
//         };
//       } else {
//         // If full task details need to be printed, extract required details from the DOM.
//         const extractText = (label) => {
//           const spans = [...clonedContent.querySelectorAll("span")];
//           const targetSpan = spans.find(
//             (span) => span.textContent.trim() === label
//           );
//           return targetSpan
//             ? targetSpan.nextElementSibling?.textContent.trim() || "N/A"
//             : "N/A";
//         };

//         // Construct task details with extracted and directly available values.
//         const taskDetails = {
//           taskId: selectedTask?.taskId || "N/A",
//           client: extractText("Client:"),
//           department: extractText("Department:"),
//           wordCount: extractText("Word Count:"),
//           status: selectedTask?.status || "N/A",
//           softDeadline: extractText("Soft Deadline:"),
//           hardDeadline: extractText("Hard Deadline:"),
//           description: selectedTask?.description || "N/A",
//         };

//         // Open a new print window and display formatted task details.
//         const printWindow = window.open("", "", "width=800,height=600");
//         printWindow.document.write(`
//           <html>
//             <head>
//               <title>Task Details</title>
//               <style>
//                 body { font-family: Arial, sans-serif; padding: 20px; color: #333; }
//                 .container { width: 100%; max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ddd; border-radius: 10px; }
//                 h2 { text-align: center; font-size: 22px; color: #007BFF; }
//                 table { width: 100%; border-collapse: collapse; margin-top: 15px; }
//                 th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
//                 th { background-color: #f5f5f5; font-weight: bold; }
//                 .status { font-weight: bold; color: green; }
//                 .deadline { font-weight: bold; color: red; }
//                 .description { margin-top: 15px; font-style: italic; }
//               </style>
//             </head>
//             <body>
//               <div class="container">
//                 <h2>📌 Task Details</h2>
//                 <table>
//                   <tr><th>Task ID:</th><td>${taskDetails.taskId}</td></tr>
//                   <tr><th>Client:</th><td>${taskDetails.client}</td></tr>
//                   <tr><th>Department:</th><td>${taskDetails.department}</td></tr>
//                   <tr><th>Word Count:</th><td>${taskDetails.wordCount}</td></tr>
//                   <tr><th>Status:</th><td class="status">${taskDetails.status}</td></tr>
//                   <tr><th>Soft Deadline:</th><td class="deadline">${taskDetails.softDeadline}</td></tr>
//                   <tr><th>Hard Deadline:</th><td class="deadline">${taskDetails.hardDeadline}</td></tr>
//                 </table>
//                 <p class="description"><strong>Description:</strong> ${taskDetails.description}</p>
//               </div>
//             </body>
//           </html>
//         `);

//         printWindow.document.close();
//         printWindow.onload = () => {
//           printWindow.print();
//           printWindow.close();
//         };
//       }
//     } else {
//       console.error("printRef.current is NULL!"); // Log error if print reference is null.
//     }
//   };


//   const setIsPaymentButtonClicked = () => {
//     sessionStorage.setItem('taskId', selectedTask.taskId);
//     window.location.replace(`/${role}/transactions`);
//   }
//   const fetchAllTasksForExport = async () => {
//     setIsExporting(true);
//     toast.info("Preparing complete task list for export...");
//     try {
//       const params = {
//         status: filter,
//         search: searchTaskQuery,
//         limit: 0, // A signal to the backend to send all matching tasks
//       };
//       const response = await axios.get(`${apiUrl}/api/task/get-task`, { params, withCredentials: true });
//       toast.success("Data ready for export!");
//       return response.data.tasks;
//     } catch (error) {
//       console.error("Error fetching all tasks for export:", error);
//       toast.error("Could not prepare export data.");
//       return [];
//     } finally {
//       setIsExporting(false);
//     }
//   };

//   const handleExportPrint = async () => {
//     const tasksToExport = await fetchAllTasksForExport();
//     if (!tasksToExport.length) return toast.warn("No tasks found to print.");
//     // Original print logic using tasksToExport
//     let printWindow = window.open("", "", "width=800,height=600");
//     printWindow.document.write("<html><head><title>Print Task List</title></head><body>");
//     printWindow.document.write("<h2>Task List</h2><table border='1'><tr><th>TaskID</th><th>Title</th><th>Word Count</th><th>Description</th><th>Client</th><th>Department</th><th>Hard Deadline</th><th>Soft Deadline</th><th>Status</th></tr>");
//     tasksToExport.forEach(task => printWindow.document.write(`<tr><td>${task.taskId}</td><td>${task.title}</td><td>${task.wordcount}</td><td>${task.description}</td><td>${task.clientName}</td><td>${task.departmentName}</td><td>${new Date(task.hard_deadline).toLocaleDateString()}</td><td>${new Date(task.soft_deadline).toLocaleDateString()}</td><td>${task.status}</td></tr>`));
//     printWindow.document.write("</table></body></html>");
//     printWindow.document.close();
//     printWindow.print();
//   };

//   const handleCopy = async () => {
//     const tasksToExport = await fetchAllTasksForExport();
//     if (!tasksToExport.length) return toast.warn("No tasks found to copy.");
//     // Original copy logic using tasksToExport
//     let textToCopy = tasksToExport.map(task => `TaskID: ${task.taskId}, Title: ${task.title}, Word Count: ${task.wordcount}, Soft Deadline: ${new Date(task.soft_deadline).toLocaleDateString()},Hard Deadline: ${new Date(task.hard_deadline).toLocaleDateString()}, Status: ${task.status}, Description: ${task.description}, Client: ${task.clientName}, Department: ${task.departmentName}`).join("\n");
//     navigator.clipboard.writeText(textToCopy).then(() => toast.success("Task data copied to clipboard!")).catch(err => console.error("Failed to copy:", err));
//   };

//   const handleExportExcel = async () => {
//     const tasksToExport = await fetchAllTasksForExport();
//     if (!tasksToExport.length) return toast.warn("No tasks found to export to Excel.");
//     // Original Excel export logic using tasksToExport
//     const excludeFields = ["_id", "employeeInvolved", "iterations", "createdAt", "updatedAt", "__v", "created_by", "updated_by", "dept_id", "org_id", "clientId"];
//     let allKeys = Object.keys(tasksToExport[0]).filter(key => !excludeFields.includes(key));
//     if (allKeys.includes("taskId")) { allKeys = allKeys.filter(key => key !== "taskId"); }
//     allKeys = ["Task ID", ...allKeys];
//     const ws = XLSX.utils.json_to_sheet(tasksToExport.map(task => ({ "Task ID": task.taskId || "", ...Object.fromEntries(allKeys.filter(key => key !== "Task ID").map(key => { let value = task[key] || ""; if (key.toLowerCase().includes("deadline") && value) { value = new Date(value).toISOString().split("T")[0]; } return [key, value]; })) })));
//     ws["!cols"] = allKeys.map(key => ({ wch: Math.max(10, key.length + 5) }));
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Tasks");
//     XLSX.writeFile(wb, "tasks_data.xlsx");
//   };

//   const handleExportPDF = async () => {
//     const tasksToExport = await fetchAllTasksForExport();
//     if (!tasksToExport.length) return toast.warn("No tasks found to export to PDF.");
//     // Original PDF export logic using tasksToExport
//     const doc = new jsPDF();
//     doc.text("Task List", 14, 10);
//     const tableColumn = ["Task ID", "Title", "Word Count", "Deadline", "Status"];
//     const tableRows = tasksToExport.map((task) => [task.taskId, task.title, task.wordcount, new Date(task.soft_deadline).toLocaleDateString(), task.status]);
//     doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
//     doc.save("tasks_data.pdf");
//   };

//   const handleExportCSV = async () => {
//     const tasksToExport = await fetchAllTasksForExport();
//     if (!tasksToExport.length) return toast.warn("No tasks found to export to CSV.");
//     // Original CSV export logic using tasksToExport
//     const ws = XLSX.utils.json_to_sheet(tasksToExport.map(task => ({ TaskID: task.taskId, Title: task.title, WordCount: task.wordcount, SoftDeadline: new Date(task.soft_deadline).toLocaleDateString(), Status: task.status })));
//     const csv = XLSX.utils.sheet_to_csv(ws);
//     const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");
//     link.href = URL.createObjectURL(blob);
//     link.download = "tasks_data.csv";
//     link.click();
//   };

//   const importTasksToAPI = async (tasks) => {
//     try {
//       const response = await axios.post(
//         `${apiUrl}/api/task/import-task-data`,
//         { tasks }, // ✅ Send tasks as a raw array
//         {
//           withCredentials: true,
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       return response.data; // ✅ Return API response
//     } catch (error) {
//       console.error("Error importing tasks:", error.message);
//       throw error; // ✅ Throw error for better debugging
//     }
//   };

//   const handleImportExcel = async (event) => {

//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();

//     reader.onload = async (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const sheetName = workbook.SheetNames[0];
//       const sheet = workbook.Sheets[sheetName];
//       const jsonData = XLSX.utils.sheet_to_json(sheet);

//       const formattedTasks = jsonData.map((task) => ({
//         title: task.title || "Untitled Task", // Ensure lowercase and provide default
//         wordcount: task.wordcount || 0,
//         description: task.description || "No Description",
//         clientId: task.clientId || "Unknown",
//         departmentName: task.departmentName || "",
//         soft_deadline: task.soft_deadline ? new Date(task.soft_deadline) : undefined,
//         hard_deadline: task.hard_deadline ? new Date(task.hard_deadline) : undefined,
//         status: task.status || "Unassigned",
//       }));

//       // ✅ Update UI first
//       setTaskData((prevTasks) => [...formattedTasks, ...prevTasks]);

//       try {
//         // ✅ API call after updating UI
//         await importTasksToAPI(formattedTasks);
//       } catch (error) {
//         console.error("Error while importing tasks:", error);
//       }
//     };

//     reader.readAsArrayBuffer(file);
//   }
//   return (
//     <>
//       {isExporting && <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-[100]"><Loading /></div>}
//       <div className="flex flex-col h-5/6 bg-gray-100">
//         <main className="flex flex-col lg:flex-row flex-1 gap-4 p-4 h-[calc(100vh-100px)]">
//           <div className="w-full lg:w-2/3 bg-white rounded-lg shadow flex flex-col">
//             <div className="p-4 border-b">
//               <div className="flex items-center justify-between mb-1">
//                 <h2 className="text-lg font-medium">Task list</h2>
//                 <div className="relative flex items-center">
//                   <div className="relative">
//                     <input
//                       type="text"
//                       placeholder="Search..."
//                       className="w-full px-3 py-2 pr-10 border rounded focus:outline-none focus:border-blue-500"
//                       value={searchTaskQuery}
//                       onChange={(e) => {
//                         setSearchTaskQuery(e.target.value);
//                         setCurrentPage(1); // Reset to first page on search
//                       }}
//                     />
//                     <FaSearch className="absolute w-5 h-5 text-gray-400 right-3 top-2" />
//                   </div>
//                   <div className="relative ml-2">
//                     <FaCog className="w-5 h-5 text-gray-500 cursor-pointer hover:text-gray-700" onClick={() => { setShowSettings(!showSettings); setShowExportOptions(false); }} />

//                     {showSettings && (
//                       <div ref={closeRef} className="absolute top-full right-0 mt-2 bg-white border rounded-lg shadow-md w-36 min-w-[150px] z-50">
//                         {(permissions.includes("AddTask") || role === "superadmin" || role === "admin") && (
//                           <button
//                             onClick={() => {
//                               setIsAddTaskModalOpen(true);
//                               setShowSettings(false);
//                             }}
//                             className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                           >
//                             <FaPlus className="mr-2" /> Add Task
//                           </button>
//                         )}
//                         <button
//                           onClick={() => {
//                             document.getElementById("fileInput").click(); // File input trigger
//                           }}
//                           className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                         >
//                           <FaFileImport className="mr-2" /> Import
//                         </button>
//                         <input
//                           type="file"
//                           id="fileInput"
//                           accept=".xlsx, .xls"
//                           className="hidden"
//                           onChange={handleImportExcel}
//                         />
//                         <div className="relative" ref={exportRef}>
//                           <button
//                             onClick={() => setShowExportOptions(!showExportOptions)}
//                             className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                           >
//                             <FaFileExport className="mr-2" /> Export
//                           </button>
//                           {showExportOptions && (
//                             <div className="absolute left-full top-0 ml-2 bg-white border rounded-lg shadow-md w-36">
//                               <button
//                                 onClick={() => {
//                                   handleExportPrint();
//                                   setShowExportOptions(false);
//                                 }}
//                                 className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                               >
//                                 <FaPrint className="mr-2" /> Print
//                               </button>
//                               <button
//                                 onClick={() => {
//                                   handleCopy();
//                                   setShowExportOptions(false);
//                                 }}
//                                 className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                               >
//                                 <FaCopy className="mr-2" /> Copy
//                               </button>
//                               <button
//                                 onClick={() => {
//                                   handleExportExcel();
//                                   setShowExportOptions(false);
//                                 }}
//                                 className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                               >
//                                 <FaFileExcel className="mr-2" /> Excel
//                               </button>
//                               <button
//                                 onClick={() => {
//                                   handleExportCSV();
//                                   setShowExportOptions(false);
//                                 }}
//                                 className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                               >
//                                 <FaFileCsv className="mr-2" /> CSV
//                               </button>
//                               <button
//                                 onClick={() => {
//                                   handleExportPDF();
//                                   setShowExportOptions(false);
//                                 }}
//                                 className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                               >
//                                 <FaFilePdf className="mr-2" /> PDF
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                         <button
//                           onClick={() => {
//                             handleReload();
//                             setShowSettings(false);
//                           }}
//                           className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
//                         >
//                           <FaSync className="mr-2" /> Reload
//                         </button>
//                       </div>
//                     )}                  </div>
//                 </div>
//               </div>
//             </div>
//             <div className="flex justify-end px-4 py-2">
//               <div className="flex items-center space-x-2 text-sm">
//                 <span className="text-gray-500">Filter</span>
//                 <select
//                   value={filter}
//                   onChange={(e) => {
//                     setFilter(e.target.value);
//                     setCurrentPage(1); // Reset to first page on filter change
//                   }}
//                   className="px-2 py-1 border rounded"
//                 >
//                   <option value={'All'}>All</option>
//                   <option value={'Running'}>Running</option>
//                   <option value={'QualityCheck'}>Quality Check</option>
//                   <option value={'Overdue'}>Overdue</option>
//                   <option value={'Delivered'}>Delivered</option>
//                   <option value={'Completed'}>Completed</option>
//                   <option value={'On Hold'}>On Hold</option>
//                   <option value={'Cancelled'}>Cancelled</option>
//                 </select>
//               </div>
//             </div>

//             {/* --- RENDER LOGIC SIMPLIFIED FOR PAGINATION --- */}
//             <div className="flex-1 px-4 pb-4 space-y-3 overflow-y-auto scrollbar-thin">
//               {isLoading ? (
//                 <div className="flex justify-center items-center h-full"><Loading /></div>
//               ) : taskData.length > 0 ? (
//                 taskData.map((task) => ( // Render directly from taskData, no .filter() or .slice() needed
//                   <div key={task._id} className={`p-3 transition-colors border rounded cursor-pointer hover:bg-gray-50 relative ${task.high_priority ? "border-red-500 bg-red-50" : "border-gray-200"}`} onClick={() => { handleTaskClick(task); setShowDropDown(false); }}>
//                     <div className="flex flex-row justify-between items-center">
//                       <div className="flex flex-col space-y-1">

//                         <h3 className="font-medium max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg break-normal whitespace-normal leading-snug">
//                           {task.title}
//                         </h3>

//                         <div className="flex  gap-5">
//                           <p className="text-sm text-gray-500">[{task.taskId}]</p>
//                           <p className="text-sm text-gray-500">
//                             Word-Count: <span className="text-blue-500">{task.wordcount}</span>
//                           </p>
//                         </div>

//                       </div>
//                       <div className="flex flex-wrap gap-2 ">
//                         <span className="px-3 py-2 text-xs text-green-700 bg-green-100 rounded-md">{new Date(task.soft_deadline).toLocaleDateString()}</span>
//                         <span className={`px-3 py-2 text-xs rounded-md ${statusColors[task.status] || "bg-red-100 text-red-700"}`}>{task.status}</span>
//                         {task.lastAssigneeName ? (
//                           <span className="px-3 py-2 text-xs font-medium rounded-md bg-blue-100 text-blue-800">{task.lastAssigneeName}</span>
//                         ) : (
//                           <span className="px-3 py-2 text-xs font-medium rounded-md bg-orange-100 text-orange-800">Unassigned</span>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center text-gray-500 py-10"><p>No tasks found.</p><p>Try adjusting your search or filter.</p></div>
//               )}
//             </div>
//             {/* --- END OF RENDER LOGIC MODIFICATION --- */}

//             {/* --- PAGINATION UI UPDATED --- */}
//             {totalPages > 1 && (
//               <div className="flex justify-center items-center gap-4 p-4 border-t">
//                 <button className={`px-3 py-1 border rounded ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"}`} disabled={currentPage === 1} onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}>Previous</button>
//                 <span className="text-sm font-medium">Page {currentPage} of {totalPages}</span>
//                 <button className={`px-3 py-1 border rounded ${currentPage >= totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"}`} disabled={currentPage >= totalPages} onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}>Next</button>
//               </div>
//             )}
//             {/* --- END OF PAGINATION UI UPDATE --- */}
//           </div>

//           {/* The entire right-side panel remains unchanged */}
//           <div className="lg:w-1/3 sm:w-full w-full relative bg-white rounded-lg shadow-lg">
//             {/* Header */}
//             {selectedTask ? (
//               <div
//                 ref={printRef}
//                 className="p-4 border-b flex items-center justify-between"
//               >
//                 <h2 className="text-xl font-semibold text-gray-800">
//                   {isTaskLogsVisible
//                     ? "Task Logs"
//                     : isUploadBriefVisible
//                       ? "Upload Brief"
//                       : isCommentModalOpen
//                         ? commentType === "query"
//                           ? "Raise Query"
//                           : "Add Comment"
//                         : isUploadPageVisible
//                           ? "Upload Page"
//                           : "Task Details"
//                   }
//                 </h2>

//                 <div className="flex space-x-2 relative">
//                   {/* Always visible icons */}
//                   <button className="p-2 text-gray-600 rounded-full hover:bg-gray-100" onClick={() => handleTaskClick(selectedTask)}>
//                     <FaInfo className="w-5 h-5" />
//                   </button>
//                   <button className="p-2 text-gray-600 rounded-full hover:bg-gray-100" onClick={handleUpload}>
//                     <FaUpload className="w-5 h-5" />
//                   </button>
//                   <button className="p-2 text-gray-600 rounded-full hover:bg-gray-100" onClick={handleUploadBrief}>
//                     <FaFileUpload className="w-5 h-5" />
//                   </button>

//                   {/* Three dots menu */}
//                   <button
//                     ref={dropdownRef}
//                     className="p-2 text-gray-600 rounded-full hover:bg-gray-200 transition"
//                     onClick={() => setShowDropDown(!showDropDown)}
//                   >
//                     <FiMoreVertical className="w-5 h-5" />
//                   </button>

//                   {/* Dropdown menu */}
//                   {showDropDown && (
//                     <div
//                       ref={dropdownRef}
//                       className="absolute right-0 mt-2 w-44 bg-white shadow-lg rounded-xl py-2 z-10 border border-gray-200"

//                     >
//                       {(permissions.includes("SeeLogs") || role === 'superadmin' || role === 'admin') && (
//                         <button
//                           className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition rounded-t-xl"
//                           onClick={() => { handleOpenTaskLogs(); setShowDropDown(false); }}
//                         >
//                           <MdOutlineAccountTree className="w-5 h-5 text-gray-600" />
//                           <span className="text-sm font-medium">Task Logs</span>
//                         </button>
//                       )}

//                       <button
//                         className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
//                         onClick={() => { handlePrint(); setShowDropDown(false); }}
//                       >
//                         <FiPrinter className="w-5 h-5 text-gray-600" />
//                         <span className="text-sm font-medium">Print</span>
//                       </button>

//                       {(permissions.includes("SeeComments") || role === 'superadmin' || role === 'admin') && (
//                         <button
//                           className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
//                           onClick={() => {
//                             handleCommentModal("comment");
//                             setShowDropDown(false);
//                           }}
//                         >
//                           <FaCommentDots className="w-5 h-5 text-gray-600" />
//                           <span className="text-sm font-medium">Add Comment</span>
//                         </button>
//                       )}

//                       {(permissions.includes("SeeQuery") || role === 'superadmin' || role === 'admin') && (
//                         <button
//                           className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition rounded-b-xl"
//                           onClick={() => {
//                             handleCommentModal("query");
//                             setShowDropDown(false);
//                           }}
//                         >
//                           <FaQuestionCircle className="w-5 h-5 text-gray-600" />
//                           <span className="text-sm font-medium">Raise Query</span>
//                         </button>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ) : (
//               <div className="p-4 border-b flex items-center justify-between">
//                 <h2 className="text-xl font-semibold text-gray-800">Task Details</h2>
//               </div>
//             )}

//             {/* Content */}
//             <div className="p-4 w-full h-[85%] flex flex-col items-center ">
//               {isTaskLogsVisible ? (
//                 <div ref={printRef} className="w-full p-6 bg-white rounded-lg">
//                   <h2 className="text-lg font-semibold text-gray-800 text-center">
//                     {selectedTask?.title || "Untitled Task"}
//                   </h2>

//                   <div className="mt-2 space-y-2 text-gray-600">
//                     <p>
//                       <span className="font-medium">Status:</span>
//                       {"  "}
//                       <span
//                         className={`px-2 py-1 text-sm font-medium rounded-md ${statusColors[selectedTask?.status] ||
//                           "bg-red-100 text-red-700"
//                           }`}
//                       >
//                         {selectedTask?.status || "Unknown"}
//                       </span>
//                     </p>
//                     <div className="mt-4">
//                       <h3 className="font-medium text-gray-700">Logs:</h3>
//                       <div className="bg-gray-100 p-3 rounded-md text-sm text-gray-700">
//                         {selectedTask?.iterations &&
//                           selectedTask?.iterations.length > 0 ? (
//                           <ul className="list-disc list-inside space-y-1">
//                             {selectedTask.iterations.map((log, index) => (
//                               <React.Fragment key={index}>
//                                 <li>
//                                   {names[log.assigned_by] || "N/A"}{" "}
//                                   <span className="font-medium text-gray-800">
//                                     {log.status === "Running"
//                                       ? "Assigned to"
//                                       : log.status}
//                                   </span>{" "}
//                                   {names[log.assigned_to] || "N/A"}{" "}
//                                   <span className="font-medium text-gray-800">
//                                     {`(${new Date(log.createdAt).toLocaleString()})`}
//                                   </span>
//                                 </li>
//                                 {log.status === "Running" && (
//                                   <li>
//                                     {names[log.assigned_to] || "N/A"}{" "}
//                                     <span className="font-medium text-gray-800">
//                                       is working on.
//                                     </span>
//                                   </li>
//                                 )}
//                               </React.Fragment>
//                             ))}
//                           </ul>
//                         ) : (
//                           <p>No logs available.</p>
//                         )}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="flex justify-center mt-6">
//                     <button
//                       className="px-6 py-2 bg-[#3758ff] hover:bg-blue-900 text-white font-semibold rounded-md shadow transition"
//                       onClick={handleCloseTaskLogs}
//                     >
//                       Close Logs
//                     </button>
//                   </div>
//                 </div>
//               ) : isUploadBriefVisible ? (
//                 <div
//                   ref={printRef}
//                   className="w-full h-[100%] space-y-6 p-4 bg-white shadow rounded-lg"
//                 >
//                   {(permissions.includes("AddBrief") || (role === 'superadmin' || role === 'admin')) && <>
//                     <input
//                       type="file"
//                       id="file"
//                       multiple
//                       onChange={handleFileChange}
//                       className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none text-sm"
//                     />
//                     <button
//                       className="mt-4 mr-2 px-4 py-2 bg-blue-600 text-white rounded-lg"
//                       onClick={handleBriefSubmit}
//                       disabled={isUploading}
//                     >
//                       {isUploading ? "Uploading..." : "Submit Brief"}
//                     </button>
//                     <button
//                       className="mt-4 px-4 py-2 bg-gray-600 text-white rounded-lg"
//                       onClick={handleCloseUploadPage}
//                     >
//                       Close
//                     </button>
//                   </>}

//                   {/* Display uploaded brief */}
//                   {brief && Array.isArray(brief) && brief.length > 0 && (
//                     <div className="w-full h-[70%] space-y-6 p-4  mt-6 overflow-auto scrollbar-thin">
//                       <h3 className="text-lg font-medium text-gray-800">Uploaded Brief</h3>
//                       {brief.map((item, index) => (
//                         <div
//                           key={index}
//                           className="text-sm text-gray-600 border-b pb-3 flex flex-col gap-2"
//                         >
//                           <p>
//                             <strong>Uploaded By:</strong> {item.employeeName || "Unknown"}
//                           </p>

//                           <div className="flex items-center justify-between flex-wrap gap-2">
//                             <div className="flex items-center gap-3 flex-1 min-w-0">
//                               {/* File Icon */}
//                               {item.uploadPath && item.name && (
//                                 <>
//                                   {["jpg", "jpeg", "png", "gif"].includes(item.name.split(".").pop().toLowerCase()) ? (
//                                     <FaFileImage
//                                       className="text-blue-500 cursor-pointer flex-shrink-0"
//                                       size={20}
//                                       onClick={() => window.open(item.uploadPath, "_blank")}
//                                     />
//                                   ) : item.name.split(".").pop().toLowerCase() === "pdf" ? (
//                                     <FaFilePdf
//                                       className="text-red-500 cursor-pointer flex-shrink-0"
//                                       size={20}
//                                       onClick={() => window.open(item.uploadPath, "_blank")}
//                                     />
//                                   ) : (
//                                     <FaFileAlt
//                                       className="text-gray-500 cursor-pointer flex-shrink-0"
//                                       size={20}
//                                       onClick={() => window.open(item.uploadPath, "_blank")}
//                                     />
//                                   )}

//                                   {/* File Name */}
//                                   <span
//                                     className="text-sm text-gray-700 truncate cursor-pointer"
//                                     onClick={() => window.open(item.uploadPath, "_blank")}
//                                     title={item.name}
//                                   >
//                                     {item.name}
//                                   </span>
//                                 </>
//                               )}
//                             </div>  </div>

//                           <p>
//                             <strong>Timestamp:</strong>{" "}
//                             {new Date(item.updatedAt).toLocaleString()}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
//                   )}


//                 </div>
//               ) : isCommentModalOpen && selectedTask?._id ? (

//                 <CommentModal
//                   isOpen={isCommentModalOpen}
//                   taskId={selectedTask?._id}
//                   type={commentType} // Pass the type to differentiate
//                   onClose={() => setIsCommentModalOpen(false)}
//                 />

//               ) : isUploadPageVisible ? (
//                 <div
//                   ref={printRef}
//                   className="w-full h-[100%] space-y-6 p-4 bg-white shadow rounded-lg"
//                 >
//                   {(permissions.includes("AddSolutions") || (role === 'superadmin' || role === 'admin')) && <>
//                     <input
//                       type="file"
//                       id="file"
//                       multiple
//                       onChange={handleFileChange}
//                       className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none text-sm"
//                     />
//                     {uploadError && (
//                       <div className="text-red-500 text-sm mt-2">
//                         {uploadError}
//                       </div>
//                     )}
//                     <button
//                       className="mt-4 mr-2 px-4 py-2 bg-blue-600 text-white rounded-lg"
//                       onClick={handleSubmit}
//                       disabled={isUploading}
//                     >
//                       {isUploading ? "Uploading..." : "Submit Solution"}
//                     </button>
//                     <button
//                       className="mt-4 px-4 py-2 bg-gray-600 text-white rounded-lg"
//                       onClick={handleCloseUploadPage}
//                     >
//                       Close
//                     </button>
//                   </>}

//                   {solution && solution.length > 0 && (
//                     <div className="w-full h-[70%] space-y-6 p-4  mt-6 overflow-auto scrollbar-thin">
//                       <h3 className="text-lg font-medium text-gray-800">Uploaded Solution</h3>
//                       {solution.map((item, index) => (
//                         <div
//                           key={index}
//                           className="text-sm text-gray-600 border-b pb-3 flex flex-col gap-2"
//                         >
//                           <p>
//                             <strong>Uploaded By:</strong>{" "}
//                             {names[item.employeeId] || "Unknown"}
//                           </p>

//                           <div className="space-y-2">
//                             <p className="font-medium">Files:</p>

//                             <ul className="space-y-2">
//                               {item.files.map((file, fileIndex) => {
//                                 const fileExtension = file.split(".").pop().toLowerCase();
//                                 const fileName = file.split("/").pop();

//                                 const handleOpenFile = () => {
//                                   window.open(file, "_blank");
//                                 };

//                                 return (
//                                   <li
//                                     key={fileIndex}
//                                     className="flex items-center justify-between flex-wrap gap-2"
//                                   >
//                                     <div className="flex items-center gap-3 flex-1 min-w-0">
//                                       {["jpg", "jpeg", "png", "gif"].includes(fileExtension) ? (
//                                         <FaFileImage
//                                           className="text-blue-500 cursor-pointer flex-shrink-0"
//                                           size={20}
//                                           onClick={handleOpenFile}
//                                         />
//                                       ) : fileExtension === "pdf" ? (
//                                         <FaFilePdf
//                                           className="text-red-500 cursor-pointer flex-shrink-0"
//                                           size={20}
//                                           onClick={handleOpenFile}
//                                         />
//                                       ) : (
//                                         <FaFileAlt
//                                           className="text-gray-500 cursor-pointer flex-shrink-0"
//                                           size={20}
//                                           onClick={handleOpenFile}
//                                         />
//                                       )}

//                                       <span
//                                         className="text-sm text-gray-700 truncate cursor-pointer"
//                                         onClick={handleOpenFile}
//                                         title={fileName}
//                                       >
//                                         {fileName}
//                                       </span>
//                                     </div>


//                                   </li>
//                                 );
//                               })}
//                             </ul>
//                           </div>

//                           <p>
//                             <strong>Timestamp:</strong>{" "}
//                             {new Date(item.timestamp).toLocaleString()}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ) : selectedTask ? (
//                 <div
//                   ref={printRef}
//                   className="w-full max-h-[75vh] overflow-y-auto space-y-6 p-4 bg-white shadow rounded-lg scrollbar-thin"

//                 >
//                   {/* Task Details Section */}
//                   <div className="flex items-center justify-between">
//                     <div className="flex items-center space-x-4">
//                       <div className="h-14 w-14 rounded-full bg-blue-100 flex items-center justify-center">
//                         <span className="text-blue-600 text-xl font-semibold uppercase">
//                           {selectedTask?.title?.[0] || "T"}
//                         </span>
//                       </div>
//                       <div>
//                         <h3 className="text-lg font-semibold text-gray-800">
//                           {selectedTask?.title}
//                         </h3>
//                         <p className="text-sm text-gray-500">
//                           Task ID: {selectedTask?.taskId}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Three-dot Menu */}
//                     <div className="">
//                       <button className="p-0 pb-6 text-gray-600 rounded-full">
//                         <FiMoreVertical
//                           className="w-4 h-4"
//                           onClick={handleToggleDropdown}
//                         />
//                       </button>
//                       {isDropDownOpen && (
//                         <div
//                           ref={dropdownRef}
//                           className="absolute right-12 top-1/4 w-48 bg-white border rounded-lg shadow-lg z-10"
//                         >
//                           {(permissions.includes("AssignTask") || (role === 'superadmin' || role === 'admin')) && <button
//                             className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
//                             onClick={() => setIsAssinTaskModalOpen(true)}
//                           >
//                             Assign
//                           </button>}
//                           {(permissions.includes("SeeTransaction") || (role === 'superadmin' || role === 'admin')) && <button className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
//                             onClick={() => setIsPaymentButtonClicked()}>
//                             Payment
//                           </button>}
//                           {(permissions.includes("CompleteTask") || (role === 'superadmin' || role === 'admin')) && <button
//                             ref={dropdownRef}
//                             className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
//                             onClick={handleCompleteTask}
//                           >
//                             Complete
//                           </button>}
//                           {(permissions.includes("DeliverTask") || (role === 'superadmin' || role === 'admin')) && <button
//                             className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
//                             onClick={handleDeliverTask}
//                           >
//                             Delivered
//                           </button>}
//                           {/* --- UPDATED: Conditional Action Buttons --- */}
//                           <div className="border-t mt-2">
//                             {(permissions.includes("UpdateTask") || (role === 'superadmin' || role === 'admin')) && <button
//                               className="block w-full px-4 py-2 text-left text-sm text-blue-600 hover:bg-gray-100"
//                               onClick={() => openTaskModal(selectedTask)}
//                             >
//                               Edit Task
//                             </button>}

//                             {/* Show Resume button if task is On Hold */}
//                             {selectedTask?.status === 'On Hold' && (permissions.includes("resumeTask") || role === 'superadmin' || role === 'admin') && (
//                               <button
//                                 className="block w-full px-4 py-2 text-left text-sm text-green-600 hover:bg-gray-100"
//                                 onClick={() => {
//                                   handleResumeTask();
//                                   setIsDropDownOpen(false);
//                                 }}
//                               >
//                                 Resume Task
//                               </button>
//                             )}

//                             {/* Show Hold and Cancel buttons if task is active (not On Hold or Cancelled) */}
//                             {selectedTask?.status !== 'On Hold' && selectedTask?.status !== 'Cancelled' && (
//                               <>
//                                 {(permissions.includes("holdTask") || role === 'superadmin' || role === 'admin') && (
//                                   <button
//                                     className="block w-full px-4 py-2 text-left text-sm text-yellow-600 hover:bg-gray-100"
//                                     onClick={() => {
//                                       setIsDropDownOpen(false);
//                                       setIsHoldModalOpen(true);
//                                     }}
//                                   >
//                                     Hold Task
//                                   </button>
//                                 )}
//                                 {(permissions.includes("CancelTask") || role === 'superadmin' || role === 'admin') && (
//                                   <button
//                                     className="block w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100"
//                                     onClick={() => {
//                                       handleCancelTask();
//                                       setIsDropDownOpen(false);
//                                     }}
//                                   >
//                                     Cancel Task
//                                   </button>
//                                 )}
//                               </>
//                             )}

//                             {(permissions.includes("DeleteTask") || (role === 'superadmin' || role === 'admin')) && <button
//                               className="block w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100"
//                               onClick={() => handleDelete(selectedTask?._id)}
//                             >
//                               Delete Task
//                             </button>}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Task Details Section */}
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     {(permissions.includes("SeeClient") || (role === 'superadmin' || role === 'admin')) && <div>
//                       <span className="text-sm font-medium text-gray-600">
//                         Client:
//                       </span>
//                       <p className="text-gray-800">
//                         {selectedTask?.clientName || "N/A"}
//                       </p>
//                     </div>}
//                     <div>
//                       <span className="text-sm font-medium text-gray-600">
//                         Department:
//                       </span>
//                       <p className="text-gray-800">
//                         {selectedTask?.departmentName || "N/A"}
//                       </p>
//                     </div>
//                     <div>
//                       <span className="text-sm font-medium text-gray-600">
//                         Word Count:
//                       </span>
//                       <p className="text-gray-800">{selectedTask?.wordcount}</p>
//                     </div>
//                     <div>
//                       <span className="text-sm font-medium text-gray-600">
//                         Status:
//                       </span>
//                       <p
//                         className={`font-medium ${selectedTask?.status === "Running"
//                           ? "text-green-700"
//                           : "text-red-700"
//                           }`}
//                       >
//                         {selectedTask?.status}
//                       </p>
//                     </div>
//                     <div>
//                       <span className="text-sm font-medium text-gray-600">
//                         Soft Deadline:
//                       </span>
//                       <p className="text-gray-800">
//                         {new Date(
//                           selectedTask?.soft_deadline
//                         ).toLocaleDateString()}
//                       </p>
//                     </div>
//                     <div>
//                       <span className="text-sm font-medium text-gray-600">
//                         Hard Deadline:
//                       </span>
//                       <p className="text-gray-800">
//                         {new Date(
//                           selectedTask?.hard_deadline
//                         ).toLocaleDateString()}
//                       </p>
//                     </div>
//                   </div>

//                   {/* Description */}
//                   <div>
//                     <span className="text-sm font-medium text-gray-600">
//                       Description:
//                     </span>
//                     <p className="text-gray-800">{selectedTask?.description}</p>
//                   </div>
//                   <div className="mt-3 flex gap-3">
//                     <button
//                       className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                       onClick={() => window.open(`/${role.toLowerCase()}/tasks/view/${selectedTask._id}`, '_blank')}
//                     >
//                       View Full Details
//                     </button>

//                     {(permissions.includes("AddSolutions") || role === 'superadmin' || role === 'admin') && (() => {
//                       const lastExtension = selectedTask?.extensionRequests?.slice(-1)[0];
//                       if (!lastExtension) return (
//                         <button
//                           className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
//                           onClick={() => setIsExtensionModalOpen(true)}
//                         >
//                           Apply Extension
//                         </button>
//                       );

//                       return (
//                         <span
//                           className={`font-semibold px-3 py-1 rounded ${lastExtension.status === "Pending" ? "text-yellow-600" :
//                             lastExtension.status === "Approved" ? "text-green-600" :
//                               "text-red-600"
//                             }`}
//                         >
//                           Extension {lastExtension.status}
//                         </span>
//                       );
//                     })()}


//                   </div>

//                 </div>
//               ) : (
//                 <div className="text-center text-gray-500">
//                   <p>No Task Selected</p>
//                   <p>Select a task to view details</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </main >
//       </div >

//       {/* All modals remain unchanged */}
//       {isAssinTaskModalOpen && (
//         <AssignTask
//           taskId={selectedTask?._id}
//           closeAssignTaskModal={closeAssignTaskModal}
//           setIsAssinTaskModalOpen={setIsAssinTaskModalOpen}
//           fetchTaskData={fetchTaskData}
//           employees={employees}
//         />
//       )}

//       {
//         isAddTaskModalOpen && (
//           <AddTask
//             closeAddTaskModal={closeAddTaskModal}
//             setIsAddTaskModalOpen={setIsAddTaskModalOpen}
//             editingTask={editingTask}
//             fetchTaskData={fetchTaskData}
//           />
//         )
//       }
//       {isExtensionModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//           <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg">
//             <h2 className="text-xl font-semibold mb-4">Request Extension</h2>

//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Soft Deadline</label>
//               <input
//                 type="datetime-local"
//                 className="w-full px-3 py-2 border rounded"
//                 value={newSoftDeadline}
//                 onChange={(e) => setNewSoftDeadline(e.target.value)}
//               />
//             </div>

//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Hard Deadline</label>
//               <input
//                 type="datetime-local"
//                 className="w-full px-3 py-2 border rounded"
//                 value={newHardDeadline}
//                 onChange={(e) => setNewHardDeadline(e.target.value)}
//               />
//             </div>

//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Reason</label>
//               <textarea
//                 className="w-full px-3 py-2 border rounded"
//                 rows={3}
//                 value={extensionReason}
//                 onChange={(e) => setExtensionReason(e.target.value)}
//               />
//             </div>

//             <div className="flex justify-end space-x-2">
//               <button
//                 onClick={() => setIsExtensionModalOpen(false)}
//                 className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleApplyExtension}
//                 className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {isHoldModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
//             <h2 className="text-xl font-semibold mb-4 text-gray-800">Hold Task</h2>
//             <textarea
//               rows={4}
//               value={holdReason}
//               onChange={(e) => setHoldReason(e.target.value)}
//               className="w-full border border-gray-300 rounded p-2 mb-4 focus:outline-none focus:ring"
//               placeholder="Enter reason for holding this task"
//             />
//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setIsHoldModalOpen(false)}
//                 className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleHoldTask}
//                 className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
//               >
//                 Confirm Hold
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </>
//   );
// };

// export default AllTasks;

import React, { useEffect, useState, useRef, useCallback } from "react";
import { FaInfo, FaUpload, FaSearch, FaCog, FaPlus, FaFileImport, FaFileExport, FaSync, FaFileUpload, FaCommentDots, FaQuestionCircle, FaFileAlt, FaPrint, FaCopy, FaFileExcel, FaFileCsv } from "react-icons/fa";
import { FaFileImage, FaFilePdf } from "react-icons/fa";
import { FiPrinter, FiMoreVertical } from "react-icons/fi";
import * as XLSX from 'xlsx';
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import AddTask from "./AddTask";
import axios from "axios";
import AssignTask from "./AssignTask";
import { MdOutlineAccountTree } from "react-icons/md";
import useOutsideClick from "../../Hooks/useClickOutside";
import { useSocket } from '../../context/SocketContext'
import { useLoggedInUser } from "../../context/LoggedUser";
import CommentModal from "./Comments";
import { useNotification } from '../../context/NotificationContext'
import { useRole } from "../../context/RoleContext";
import { usePermissions } from "../../context/PermissionContext";
import Loading from "../../components/Loading";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const AllTasks = () => {
  const navigate = useNavigate();
  const { role } = useRole();

  const [entries, setEntries] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [taskData, setTaskData] = useState([]); 
  const [isLoading, setIsLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false); 
  const [searchTaskQuery, setSearchTaskQuery] = useState("");

  const [isHoldModalOpen, setIsHoldModalOpen] = useState(false);
  const [holdReason, setHoldReason] = useState("");

  const [showExportOptions, setShowExportOptions] = useState(false);
  const [filter, setFilter] = useState("All");
  const [file, setFile] = useState(null);
  const [taskStatus, setTaskStatus] = useState("");
  const [uploadError, setUploadError] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false)
  const [isAddTaskModalOpen, setIsAddTaskModalOpen] = useState(false);
  const [solution, setSolution] = useState(null);
  const [brief, setBrief] = useState(null);
  const [isAssinTaskModalOpen, setIsAssinTaskModalOpen] = useState(false);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [isTaskLogsVisible, setIsTaskLogsVisible] = useState(false);
  const [isUploadPageVisible, setIsUploadPageVisible] = useState(false);
  const [isUploadBriefVisible, setIsUploadBriefVisible] = useState(false);
  const [names, setNames] = useState({});
  const [isExtensionModalOpen, setIsExtensionModalOpen] = useState(false);
  const [extensionReason, setExtensionReason] = useState("");
  const [newSoftDeadline, setNewSoftDeadline] = useState("");
  const [newHardDeadline, setNewHardDeadline] = useState("");
  const [commentType, setCommentType] = useState("");
  const { permissions } = usePermissions();
  const { loggedInUser } = useLoggedInUser();
  const apiUrl = process.env.REACT_APP_API_URL;
  const { createNotification } = useNotification();
  const location = useLocation();
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    if (location.state?.title) {
      setSearchTaskQuery(location.state.title);

    }
  }, [location.state]);

  const printRef = useRef();
  const { socket } = useSocket()
  const closeRef = useRef();
  const dropdownRef = useRef();
  const exportRef = useRef();
  useOutsideClick(closeRef, () => setShowSettings(false));
  useOutsideClick(dropdownRef, () => setIsDropDownOpen(false));
  useOutsideClick(exportRef, () => setShowExportOptions(false));
  const dropDownMenuRef = useRef();
  useOutsideClick(dropDownMenuRef, () => setShowDropDown(false));

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/team/get-team`, {
          withCredentials: true,
        });

        if (response.data.success) {
          setEmployees(response.data.team);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);


  const allowedTypes = [
    // 📷 Images
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/gif",
    "image/webp",
    "image/bmp",
    "image/svg+xml",
    "image/tiff",
    "image/x-icon", // .ico

    // 📄 PDF
    "application/pdf",
    "text/plain", // .txt, .log, .env
    "application/json",
    "application/xml",
    "text/xml",

    // 🎞️ Video
    "video/mp4",
    "video/x-msvideo", // .avi
    "video/x-matroska", // .mkv
    "video/webm",
    "video/ogg",
    "video/3gpp", // .3gp
    "video/quicktime", // .mov
    "video/x-flv", // .flv
    "video/mpeg", // .mpeg

    // 🔊 Audio
    "audio/mpeg", // .mp3
    "audio/wav",
    "audio/mp4",
    "audio/x-ms-wma",
    "audio/ogg",
    "audio/webm",
    "audio/x-flac",
    "audio/aac",
    "audio/midi",

    // 🧾 Microsoft Word
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-word.document.macroEnabled.12", // .docm

    // 📊 Microsoft Excel (Old + New)
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/vnd.ms-excel.sheet.macroEnabled.12", // .xlsm

    // 📽️ Microsoft PowerPoint (Old + New)
    "application/vnd.ms-powerpoint", // .ppt
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12", // .pptm

    // 📅 MS Project / Outlook / Visio
    "application/vnd.ms-project", // .mpp
    "application/vnd.ms-outlook", // .msg
    "application/vnd.visio", // .vsd, .vsdx

    // 📈 Tableau & Power BI (fallback MIME)
    "application/octet-stream", // .pbix, .twb, .twbx
    "application/x-tableau", // optional for some Tableau configs
    "text/x-r-markdown", // .rmd

    // 🗜️ Archives
    "application/zip",
    "application/x-zip-compressed",
    "application/x-rar-compressed",
    "application/x-compressed",
    "multipart/x-zip",

    "application/x-7z-compressed",
    "application/x-tar",
    "application/gzip",
    "application/x-bzip",
    "application/x-bzip2",
    "application/x-compressed",
    "application/x-xz",

    // 👨‍💻 Programming / Scripting / Source Code
    "text/plain", // .txt, .env, etc.
    "text/x-python", // .py
    "text/x-java-source", // .java
    "text/x-csrc", // .c
    "text/x-c++src", // .cpp
    "text/javascript", // .js
    "application/x-typescript", // .ts
    "application/x-httpd-php", // .php
    "application/x-sh", // .sh
    "application/x-bash", // .bash
    "application/sql", // .sql
    "application/x-java-archive", // .jar
    "application/x-msdownload", // .exe
    "application/x-powershell", // .ps1
    "application/x-r", // .r
    "application/x-csh", // .csh
    "text/x-script.perl", // .pl
    "text/x-ruby", // .rb
    "application/x-lua", // .lua
    "text/x-go", // .go
    "text/x-kotlin", // .kt
    "text/x-swift", // .swift
    "text/x-scala", // .scala
    "text/x-typescript", // .ts
    "application/x-dart", // .dart
    "application/x-vbscript", // .vbs

    // 📝 Dev Config / Markup / Data
    "text/html",
    "text/css",
    "application/json",
    "application/xml",
    "text/csv",
    "text/tsv",
    "application/x-yaml", // .yaml
    "application/x-toml", // .toml
    "application/x-ini", // .ini
    "text/markdown", // .md
    "application/x-markdown", // .md

    ///
    "text/x-r-markdown",            // .Rmd files
    "text/plain",                   // fallback for .Rmd
    "application/vnd.tableau.twbx", // Tableau TWBX files
    "application/octet-stream",

    // ⚠️ Fallback
    "application/octet-stream", // any unknown but allowed binaries
  ];
  const validExtensions = [".rmd", ".twbx", ".pbix", '.pbix', '.twb', '.twbx', '.rmd',
    '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
    '.pdf', '.zip', '.rar', '.7z',
    '.js', '.ts', '.py', '.java', '.cpp', '.c',
    '.html', '.css', '.json', '.xml', '.csv', '.txt'];

  const fetchNameWithId = useCallback(async (userId) => {
    if (!userId) return null;
    try {
      const response = await axios.get(`${apiUrl}/api/fetchUser/${userId}`, { withCredentials: true });
      return response.data.name;
    } catch (error) {
      console.error(`Error fetching user name for ID ${userId}:`, error);
      return "N/A";
    }
  }, [apiUrl]);

  const fetchTaskData = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = {
        page: currentPage,
        limit: entries,
        status: filter,
        search: searchTaskQuery,
      };
      const response = await axios.get(`${apiUrl}/api/task/get-task`, { params, withCredentials: true });
      setTaskData(response.data.tasks);
      setTotalPages(response.data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Failed to fetch tasks.");
      setTaskData([]);
      setTotalPages(1);
    } finally {
      setIsLoading(false);
    }
  }, [apiUrl, currentPage, entries, filter, searchTaskQuery]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchTaskData();
    }, 500); // 500ms delay after user stops typing
    return () => clearTimeout(handler);
  }, [searchTaskQuery, filter, currentPage, entries, fetchTaskData]);

  const statusColors = { Delayed: "bg-red-50 text-red-800", Unassigned: "bg-orange-50 text-orange-900", "Assigned to": "bg-blue-50 text-blue-900", Running: "bg-green-50 text-green-900", "Approved By": "bg-purple-50 text-purple-900", "Quality Check": "bg-yellow-50 text-yellow-900", "Quality Check done by": "bg-gray-50 text-gray-900", Completed: "bg-teal-50 text-teal-900", Delivered: "bg-indigo-50 text-indigo-900", 'On Hold': 'bg-yellow-100 text-yellow-800', 'Cancelled': 'bg-gray-200 text-gray-800' };

  const handleReload = useCallback(() => fetchTaskData(), [fetchTaskData]);

  const closeAddTaskModal = () => setIsAddTaskModalOpen(false);
  const closeAssignTaskModal = () => setIsAssinTaskModalOpen(false);

  const handleTaskClick = useCallback((task) => {
    setSelectedTask(task);
    setIsTaskLogsVisible(false);
    setIsUploadPageVisible(false);
    setIsUploadBriefVisible(false);
    setIsCommentModalOpen(false);
  }, []);


  const handleToggleDropdown = () => { setIsDropDownOpen(!isDropDownOpen); };

  // const fetchSolution = async (taskId) => {
  //   try {
  //     const response = await axios.get(
  //       `${apiUrl}/api/task/get-solution/${taskId}`,
  //       { withCredentials: true }
  //     );
  //     setSolution(response.data.solutions);
  //   } catch (error) { }
  //   finally {
  //     // setLoading(false);
  //   }
  // };
  const fetchSolution = async (taskId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/task/get-solution/${taskId}`,
        { withCredentials: true }
      );
      setSolution(response.data.solutions);
    } catch (error) {
      setSolution([]); // Set to empty array on error to prevent UI crash
    }
  };

  const handleApplyExtension = async () => {

    if (!newSoftDeadline || !newHardDeadline || !extensionReason) {
      toast.error("Please fill all fields for the extension request.");
      return;
    }
    if (new Date(newHardDeadline) < new Date(newSoftDeadline)) {
      toast.error("Hard Deadline cannot be earlier than Soft Deadline.");
      return;
    }

    let managerId = null;
    if (selectedTask && selectedTask.iterations && selectedTask.iterations.length > 0) {
      const lastIteration = selectedTask.iterations[selectedTask.iterations.length - 1];
      managerId = lastIteration.assigned_by;
    }

    if (!managerId) {
      toast.error("Cannot request extension: The task has no assignment history.");

      return;
    }


    const payload = {
      new_soft_deadline: newSoftDeadline,
      new_hard_deadline: newHardDeadline,
      reason: extensionReason,
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/task/${selectedTask._id}/request-extension`,
        payload,
        { withCredentials: true }
      );

      const updatedTask = response.data.task;

      if (!updatedTask) {
        console.error("ERROR: The server response did not include 'task' object.");
        toast.error("Request submitted, but failed to get task update from server.");
        return;
      }

      const notificationMessage = `${loggedInUser.name} has requested an extension for task '${updatedTask.title}' which you assigned.`;

      socket.emit("send-notification", {
        to: managerId,
        message: notificationMessage,
        notDesc: updatedTask.taskId,
        sender: loggedInUser
      });

      await createNotification({
        sender: loggedInUser._id,
        receiver: [managerId],
        message: notificationMessage,
        notDesc: updatedTask.taskId,
      });

      toast.success("Extension request submitted successfully!");

      setTaskData((prev) =>
        prev.map((task) => (task._id === selectedTask._id ? updatedTask : task))
      );
      setIsExtensionModalOpen(false);

    } catch (err) {
      if (err.response) {
        toast.error(err.response.data.message || "An error occurred on the server.");
      } else {
        toast.error("Could not connect to the server. Please check your connection.");
      }
    }
  };
  const handleCancelTask = async () => {
    if (!selectedTask) return;
    try {
      const response = await axios.post(
        `${apiUrl}/api/task/cancel/${selectedTask._id}`,
        {},
        { withCredentials: true }
      );
      toast.success("Task cancelled successfully!");
      fetchTaskData(); // Refresh task list
      setSelectedTask(response.data.task); // Update local selected task
    } catch (error) {
      console.error("Cancel task error:", error);
      toast.error(error?.response?.data?.message || "Failed to cancel task.");
    }
  };
  const handleHoldTask = async () => {
    if (!holdReason.trim()) return toast.warn("Please enter a reason.");
    try {
      const response = await axios.post(
        `${apiUrl}/api/task/hold/${selectedTask._id}`,
        { reason: holdReason },
        { withCredentials: true }
      );
      toast.success("Task put on hold successfully!");
      fetchTaskData(); // Refresh task list
      setSelectedTask(response.data.task);
      setIsHoldModalOpen(false);
      setHoldReason("");
    } catch (error) {
      console.error("Hold task error:", error);
      toast.error(error?.response?.data?.message || "Failed to hold task.");
    }
  };

  const handleResumeTask = async () => {
    if (!selectedTask) return;
    try {
      const response = await axios.post(
        `${apiUrl}/api/task/resume/${selectedTask._id}`,
        {}, // No payload needed
        { withCredentials: true }
      );
      toast.success("Task resumed successfully!");
      fetchTaskData(); // Refresh the list of tasks
      setSelectedTask(response.data.task); // Update the currently selected task view
    } catch (error) {
      console.error("Resume task error:", error);
      toast.error(error?.response?.data?.message || "Failed to resume task.");
    }
  };


  const fetchBrief = async (taskId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/task/get-brief/${taskId}`,
        { withCredentials: true }
      );
      setBrief(response.data.briefs);
    } catch (error) {
      setBrief([]); // Set to empty array on error
    }
  };


  useEffect(() => { if (selectedTask) { fetchSolution(selectedTask._id); fetchBrief(selectedTask._id); } }, [selectedTask]);

  const handleDelete = async (taskId) => {
    setIsLoading(true);
    try {
      await axios.delete(`${apiUrl}/api/task/delete-task/${taskId}`, {
        withCredentials: true,
      });
      setTaskData((prev) => prev.filter((task) => task._id !== taskId));
      if (selectedTask?._id === taskId || editingTask?._id === taskId) {
        setSelectedTask(null);
      }
      toast.success("Task deleted successfully!");
    } catch (error) {
      console.error("Error deleting task:", error);
      toast.error("Failed to delete task. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (status) => {
    try {
      let endpoint =
        status === "Completed"
          ? `${apiUrl}/api/task/complete-task`
          : `${apiUrl}/api/task/deliver-task`;

      const response = await axios.put(
        endpoint,
        { taskId: selectedTask._id, employeeId: loggedInUser._id },
        { withCredentials: true }
      );



      // Ensure we are comparing with strict equality
      if (response.status === 200 && response.data.task.status === "Delivered") {
        const employees = response.data.task.iterations;

        if (employees.length > 0) {
          // Emit event to each assigned employee
          employees.forEach(employee => {
            socket.emit("deliver-task", {
              to: employee.assigned_to,
              message: `Task Delivered ${response.data.task.taskId}`,
              date: new Date(),
              notDesc: response.data.task.taskId,
            });
          });

          // Create notifications for assigned employees
          await createNotification({
            sender: loggedInUser._id,
            receiver: employees.map(employee => employee.assigned_to),
            message: "Task Delivered",
            notDesc: response.data.task.taskId,
          });


        } else {
          console.warn("No employees assigned for notification");
        }
      }

      if (response.status === 200 && response.data.task.status === "Completed") {
        const employees = response.data.task.iterations;

        if (employees.length > 0) {
          // Emit event to each assigned employee
          employees.forEach(employee => {

            socket.emit("complete-task", {
              to: employee.assigned_to,
              message: `Task completed ${response.data.task.taskId}`,
              date: new Date(),
              notDesc: response.data.task.taskId,
            });
          });

          // Create notifications for assigned employees
          await createNotification({
            sender: loggedInUser._id,
            receiver: employees.map(employee => employee.assigned_to),
            message: "Task Completed",
            notDesc: response.data.task.taskId,
          });

          // console.log("Notification created successfully");
        } else {
          console.warn("No employees assigned for notification");
        }
      }

      // Update the local task status
      setTaskStatus(status);
      setTaskData((prevTasks) =>
        prevTasks.map((task) =>
          task._id === selectedTask._id ? { ...task, status } : task
        )
      );
    } catch (error) {
      console.error("Error updating task status:", error);
    }
  };

  const handleOpenTaskLogs = () => {
    setIsTaskLogsVisible(true);
    setIsUploadPageVisible(false);
    setIsUploadBriefVisible(false);
    setIsCommentModalOpen(false);

  };

  const handleCloseTaskLogs = () => { setIsTaskLogsVisible(false); };
  const handleCompleteTask = () => {
    handleStatusChange("Completed");
    fetchTaskData();
  };

  const handleDeliverTask = () => {
    handleStatusChange("Delivered");
  };

  const openTaskModal = (task) => {
    setIsAddTaskModalOpen(true); // Open the task modal
    setEditingTask(task); // Set the selected task for editing
  };

  const handleUpload = () => {
    setIsUploadPageVisible(true);
    setIsTaskLogsVisible(false);
    setIsUploadBriefVisible(false);
    setIsCommentModalOpen(false);
  };

  const handleCommentModal = (type = "comment") => {
    setCommentType(type);
    setIsUploadPageVisible(false);
    setIsTaskLogsVisible(false);
    setIsUploadBriefVisible(false);
    setIsCommentModalOpen(true);
  }
  const handleCloseUploadPage = () => {
    setIsUploadPageVisible(false);
    setIsUploadBriefVisible(false);
  };


  const handleFileChange = (event) => {
  const selectedFiles = Array.from(event.target.files);

  const invalidFiles = selectedFiles.filter((file) => {
    const fileName = file.name.toLowerCase();
    const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));
    return !(allowedTypes.includes(file.type) || hasValidExtension);
  });

  if (invalidFiles.length > 0) {
    setUploadError("One or more files are invalid.");
    return;
  }

  setFile(selectedFiles); 
  setUploadError(null);
};

 const handleSubmit = async () => {
  if (!file || file.length === 0) {
    toast.warn('Please select at least one file before submitting.');
    return;
  }

  setIsUploading(true);
  setUploadError(null);
  const formData = new FormData();
  file.forEach((f) => formData.append("file", f)); 
  formData.append("taskId", selectedTask._id);

  try {
    const response = await axios.post(
      `${apiUrl}/api/task/add-solution/${selectedTask._id}`,
      formData,
      { withCredentials: true }
    );
    toast.success("Files uploaded successfully!");
    setFile(null);
    setSolution(response.data.solutions);
    fetchSolution(selectedTask._id);
  } catch (error) {
    console.error("Upload error:", error);
    setUploadError("Failed to upload files. Please try again.");
  } finally {
    setIsUploading(false);
  }
};



  const handleUploadBrief = () => {
    setIsUploadBriefVisible(true); // Make the upload brief section visible
    setIsUploadPageVisible(false); // Hide the main upload page
    setIsTaskLogsVisible(false); // Hide the task logs section
  };


  const handleBriefSubmit = async () => {
  if (!file || file.length === 0) {
    toast.warn("Please select at least one file before submitting.");
    return;
  }

  setIsUploading(true);
  setUploadError(null);
  const formData = new FormData();
  file.forEach((f) => formData.append("file", f)); // ✅ multiple files
  formData.append("taskId", selectedTask._id);

  try {
    const response = await axios.post(
      `${apiUrl}/api/task/add-brief/${selectedTask._id}`,
      formData,
      { withCredentials: true }
    );
    fetchBrief(selectedTask._id);
    toast.success('Brief uploaded successfully!');
    setFile(null);
  } catch (error) {
    console.error("Upload error:", error);
    setUploadError("Failed to upload brief. Please try again.");
  } finally {
    setIsUploading(false);
  }
};


  useEffect(() => {
    if (!selectedTask || !selectedTask.iterations) return;

    const fetchNames = async () => {
      const fetchedNames = {}; // Object to store fetched names.

      const promises = selectedTask.iterations.map(async (log) => {
        if (log.assigned_by && !fetchedNames[log.assigned_by]) {
          fetchedNames[log.assigned_by] = await fetchNameWithId(
            log.assigned_by
          );
        }
        if (log.assigned_to && !fetchedNames[log.assigned_to]) {
          fetchedNames[log.assigned_to] = await fetchNameWithId(
            log.assigned_to
          );
        }
      });

      await Promise.all(promises); // Ensure all names are fetched before proceeding.
      setNames(fetchedNames); // Update state with the fetched names.
    };

    fetchNames();
  }, [selectedTask, fetchNameWithId]);


  const handlePrint = () => {
    if (printRef.current) {
      const clonedContent = printRef.current.cloneNode(true);

      clonedContent
        .querySelectorAll("button, svg")
        .forEach((el) => el.remove());


      if (isTaskLogsVisible) {
        // If only task logs should be printed, extract relevant data.
        const taskLogs = selectedTask?.iterations?.map(
          (log, index) =>
            `${index + 1}. ${log.assigned_by} assigned to ${log.assigned_to
            } - ${log.status}`
        ) || ["No logs available."];


        // Open a new print window and display formatted task logs.
        const printWindow = window.open("", "", "width=800,height=600");
        printWindow.document.write(`
          <html>
            <head>
              <title>Task Logs</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 20px; color: #333; }
                .container { width: 100%; max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ddd; border-radius: 10px; }
                h2 { text-align: center; font-size: 22px; color: #007BFF; }
                .logs { margin-top: 20px; padding: 10px; background: #f9f9f9; border-radius: 5px; }
              </style>
            </head>
            <body>
              <div class="container">
                <h2>📜 Task Logs</h2>
                <div class="logs">
                  <ul>
                    ${taskLogs.map((log) => `<li>${log}</li>`).join("")}
                  </ul>
                </div>
              </div>
            </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
        };
      } else {
        // If full task details need to be printed, extract required details from the DOM.
        const extractText = (label) => {
          const spans = [...clonedContent.querySelectorAll("span")];
          const targetSpan = spans.find(
            (span) => span.textContent.trim() === label
          );
          return targetSpan
            ? targetSpan.nextElementSibling?.textContent.trim() || "N/A"
            : "N/A";
        };

        // Construct task details with extracted and directly available values.
        const taskDetails = {
          taskId: selectedTask?.taskId || "N/A",
          client: extractText("Client:"),
          department: extractText("Department:"),
          wordCount: extractText("Word Count:"),
          status: selectedTask?.status || "N/A",
          softDeadline: extractText("Soft Deadline:"),
          hardDeadline: extractText("Hard Deadline:"),
          description: selectedTask?.description || "N/A",
        };

        // Open a new print window and display formatted task details.
        const printWindow = window.open("", "", "width=800,height=600");
        printWindow.document.write(`
          <html>
            <head>
              <title>Task Details</title>
              <style>
                body { font-family: Arial, sans-serif; padding: 20px; color: #333; }
                .container { width: 100%; max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ddd; border-radius: 10px; }
                h2 { text-align: center; font-size: 22px; color: #007BFF; }
                table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                th, td { padding: 10px; text-align: left; border-bottom: 1px solid #ddd; }
                th { background-color: #f5f5f5; font-weight: bold; }
                .status { font-weight: bold; color: green; }
                .deadline { font-weight: bold; color: red; }
                .description { margin-top: 15px; font-style: italic; }
              </style>
            </head>
            <body>
              <div class="container">
                <h2>📌 Task Details</h2>
                <table>
                  <tr><th>Task ID:</th><td>${taskDetails.taskId}</td></tr>
                  <tr><th>Client:</th><td>${taskDetails.client}</td></tr>
                  <tr><th>Department:</th><td>${taskDetails.department}</td></tr>
                  <tr><th>Word Count:</th><td>${taskDetails.wordCount}</td></tr>
                  <tr><th>Status:</th><td class="status">${taskDetails.status}</td></tr>
                  <tr><th>Soft Deadline:</th><td class="deadline">${taskDetails.softDeadline}</td></tr>
                  <tr><th>Hard Deadline:</th><td class="deadline">${taskDetails.hardDeadline}</td></tr>
                </table>
                <p class="description"><strong>Description:</strong> ${taskDetails.description}</p>
              </div>
            </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
        };
      }
    } else {
      console.error("printRef.current is NULL!"); // Log error if print reference is null.
    }
  };


  const setIsPaymentButtonClicked = () => {
    sessionStorage.setItem('taskId', selectedTask.taskId);
    window.location.replace(`/${role}/transactions`);
  }
  const fetchAllTasksForExport = async () => {
    setIsExporting(true);
    toast.info("Preparing complete task list for export...");
    try {
      const params = {
        status: filter,
        search: searchTaskQuery,
        limit: 0, // A signal to the backend to send all matching tasks
      };
      const response = await axios.get(`${apiUrl}/api/task/get-task`, { params, withCredentials: true });
      toast.success("Data ready for export!");
      return response.data.tasks;
    } catch (error) {
      console.error("Error fetching all tasks for export:", error);
      toast.error("Could not prepare export data.");
      return [];
    } finally {
      setIsExporting(false);
    }
  };

  const handleExportPrint = async () => {
    const tasksToExport = await fetchAllTasksForExport();
    if (!tasksToExport.length) return toast.warn("No tasks found to print.");
    // Original print logic using tasksToExport
    let printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write("<html><head><title>Print Task List</title></head><body>");
    printWindow.document.write("<h2>Task List</h2><table border='1'><tr><th>TaskID</th><th>Title</th><th>Word Count</th><th>Description</th><th>Client</th><th>Department</th><th>Hard Deadline</th><th>Soft Deadline</th><th>Status</th></tr>");
    tasksToExport.forEach(task => printWindow.document.write(`<tr><td>${task.taskId}</td><td>${task.title}</td><td>${task.wordcount}</td><td>${task.description}</td><td>${task.clientName}</td><td>${task.departmentName}</td><td>${new Date(task.hard_deadline).toLocaleDateString()}</td><td>${new Date(task.soft_deadline).toLocaleDateString()}</td><td>${task.status}</td></tr>`));
    printWindow.document.write("</table></body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  const handleCopy = async () => {
    const tasksToExport = await fetchAllTasksForExport();
    if (!tasksToExport.length) return toast.warn("No tasks found to copy.");
    // Original copy logic using tasksToExport
    let textToCopy = tasksToExport.map(task => `TaskID: ${task.taskId}, Title: ${task.title}, Word Count: ${task.wordcount}, Soft Deadline: ${new Date(task.soft_deadline).toLocaleDateString()},Hard Deadline: ${new Date(task.hard_deadline).toLocaleDateString()}, Status: ${task.status}, Description: ${task.description}, Client: ${task.clientName}, Department: ${task.departmentName}`).join("\n");
    navigator.clipboard.writeText(textToCopy).then(() => toast.success("Task data copied to clipboard!")).catch(err => console.error("Failed to copy:", err));
  };

  const handleExportExcel = async () => {
    const tasksToExport = await fetchAllTasksForExport();
    if (!tasksToExport.length) return toast.warn("No tasks found to export to Excel.");
    // Original Excel export logic using tasksToExport
    const excludeFields = ["_id", "employeeInvolved", "iterations", "createdAt", "updatedAt", "__v", "created_by", "updated_by", "dept_id", "org_id", "clientId"];
    let allKeys = Object.keys(tasksToExport[0]).filter(key => !excludeFields.includes(key));
    if (allKeys.includes("taskId")) { allKeys = allKeys.filter(key => key !== "taskId"); }
    allKeys = ["Task ID", ...allKeys];
    const ws = XLSX.utils.json_to_sheet(tasksToExport.map(task => ({ "Task ID": task.taskId || "", ...Object.fromEntries(allKeys.filter(key => key !== "Task ID").map(key => { let value = task[key] || ""; if (key.toLowerCase().includes("deadline") && value) { value = new Date(value).toISOString().split("T")[0]; } return [key, value]; })) })));
    ws["!cols"] = allKeys.map(key => ({ wch: Math.max(10, key.length + 5) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tasks");
    XLSX.writeFile(wb, "tasks_data.xlsx");
  };

  const handleExportPDF = async () => {
    const tasksToExport = await fetchAllTasksForExport();
    if (!tasksToExport.length) return toast.warn("No tasks found to export to PDF.");
    // Original PDF export logic using tasksToExport
    const doc = new jsPDF();
    doc.text("Task List", 14, 10);
    const tableColumn = ["Task ID", "Title", "Word Count", "Deadline", "Status"];
    const tableRows = tasksToExport.map((task) => [task.taskId, task.title, task.wordcount, new Date(task.soft_deadline).toLocaleDateString(), task.status]);
    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("tasks_data.pdf");
  };

  const handleExportCSV = async () => {
    const tasksToExport = await fetchAllTasksForExport();
    if (!tasksToExport.length) return toast.warn("No tasks found to export to CSV.");
    // Original CSV export logic using tasksToExport
    const ws = XLSX.utils.json_to_sheet(tasksToExport.map(task => ({ TaskID: task.taskId, Title: task.title, WordCount: task.wordcount, SoftDeadline: new Date(task.soft_deadline).toLocaleDateString(), Status: task.status })));
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "tasks_data.csv";
    link.click();
  };

  const importTasksToAPI = async (tasks) => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/task/import-task-data`,
        { tasks }, // ✅ Send tasks as a raw array
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data; // ✅ Return API response
    } catch (error) {
      console.error("Error importing tasks:", error.message);
      throw error; // ✅ Throw error for better debugging
    }
  };

  const handleImportExcel = async (event) => {

    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const formattedTasks = jsonData.map((task) => ({
        title: task.title || "Untitled Task", // Ensure lowercase and provide default
        wordcount: task.wordcount || 0,
        description: task.description || "No Description",
        clientId: task.clientId || "Unknown",
        departmentName: task.departmentName || "",
        soft_deadline: task.soft_deadline ? new Date(task.soft_deadline) : undefined,
        hard_deadline: task.hard_deadline ? new Date(task.hard_deadline) : undefined,
        status: task.status || "Unassigned",
      }));

      // ✅ Update UI first
      setTaskData((prevTasks) => [...formattedTasks, ...prevTasks]);

      try {
        // ✅ API call after updating UI
        await importTasksToAPI(formattedTasks);
      } catch (error) {
        console.error("Error while importing tasks:", error);
      }
    };

    reader.readAsArrayBuffer(file);
  }
  return (
    <>
      {isExporting && <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-[100]"><Loading /></div>}
      <div className="flex flex-col h-5/6 bg-gray-100">
        <main className="flex flex-col lg:flex-row flex-1 gap-4 p-4 h-[calc(100vh-100px)]">
         
          <div className="w-full lg:w-2/3 bg-white rounded-lg shadow flex flex-col">
            <div className="p-4 border-b">
              <div className="flex items-center justify-between mb-1">
                <h2 className="text-lg font-medium">Task list</h2>
                <div className="relative flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="w-full px-3 py-2 pr-10 border rounded focus:outline-none focus:border-blue-500"
                      value={searchTaskQuery}
                      onChange={(e) => {
                        setSearchTaskQuery(e.target.value);
                        setCurrentPage(1); // Reset to first page on search
                      }}
                    />
                    <FaSearch className="absolute w-5 h-5 text-gray-400 right-3 top-2" />
                  </div>
                  <div className="relative ml-2">
                    <FaCog className="w-5 h-5 text-gray-500 cursor-pointer hover:text-gray-700" onClick={() => { setShowSettings(!showSettings); setShowExportOptions(false); }} />

                    {showSettings && (
                      <div ref={closeRef} className="absolute top-full right-0 mt-2 bg-white border rounded-lg shadow-md w-36 min-w-[150px] z-50">
                        {(permissions.includes("AddTask") || role === "superadmin" || role === "admin") && (
                          <button
                            onClick={() => {
                              setIsAddTaskModalOpen(true);
                              setShowSettings(false);
                            }}
                            className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                          >
                            <FaPlus className="mr-2" /> Add Task
                          </button>
                        )}
                        <button
                          onClick={() => {
                            document.getElementById("fileInput").click(); // File input trigger
                          }}
                          className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                        >
                          <FaFileImport className="mr-2" /> Import
                        </button>
                        <input
                          type="file"
                          id="fileInput"
                          accept=".xlsx, .xls"
                          className="hidden"
                          onChange={handleImportExcel}
                        />
                        <div className="relative" ref={exportRef}>
                          <button
                            onClick={() => setShowExportOptions(!showExportOptions)}
                            className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                          >
                            <FaFileExport className="mr-2" /> Export
                          </button>
                          {showExportOptions && (
                            <div className="absolute left-full top-0 ml-2 bg-white border rounded-lg shadow-md w-36">
                              <button
                                onClick={() => {
                                  handleExportPrint();
                                  setShowExportOptions(false);
                                }}
                                className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                              >
                                <FaPrint className="mr-2" /> Print
                              </button>
                              <button
                                onClick={() => {
                                  handleCopy();
                                  setShowExportOptions(false);
                                }}
                                className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                              >
                                <FaCopy className="mr-2" /> Copy
                              </button>
                              <button
                                onClick={() => {
                                  handleExportExcel();
                                  setShowExportOptions(false);
                                }}
                                className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                              >
                                <FaFileExcel className="mr-2" /> Excel
                              </button>
                              <button
                                onClick={() => {
                                  handleExportCSV();
                                  setShowExportOptions(false);
                                }}
                                className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                              >
                                <FaFileCsv className="mr-2" /> CSV
                              </button>
                              <button
                                onClick={() => {
                                  handleExportPDF();
                                  setShowExportOptions(false);
                                }}
                                className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                              >
                                <FaFilePdf className="mr-2" /> PDF
                              </button>
                            </div>
                          )}
                        </div>
                        <button
                          onClick={() => {
                            handleReload();
                            setShowSettings(false);
                          }}
                          className="flex items-center w-full px-4 py-2 text-sm text-gray-800 hover:bg-blue-500 hover:text-white transition duration-200"
                        >
                          <FaSync className="mr-2" /> Reload
                        </button>
                      </div>
                    )}                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-end px-4 py-2">
              <div className="flex items-center space-x-2 text-sm">
                <span className="text-gray-500">Filter</span>
                <select
                  value={filter}
                  onChange={(e) => {
                    setFilter(e.target.value);
                    setCurrentPage(1); // Reset to first page on filter change
                  }}
                  className="px-2 py-1 border rounded"
                >
                  <option value={'All'}>All</option>
                  <option value={'Running'}>Running</option>
                  <option value={'QualityCheck'}>Quality Check</option>
                  <option value={'Overdue'}>Overdue</option>
                  <option value={'Delivered'}>Delivered</option>
                  <option value={'Completed'}>Completed</option>
                  <option value={'On Hold'}>On Hold</option>
                  <option value={'Cancelled'}>Cancelled</option>
                </select>
              </div>
            </div>

            {/* --- RENDER LOGIC SIMPLIFIED FOR PAGINATION --- */}
            <div className="flex-1 px-4 pb-4 space-y-3 overflow-y-auto scrollbar-thin">
              {isLoading ? (
                <div className="flex justify-center items-center h-full"><Loading /></div>
              ) : taskData.length > 0 ? (
                taskData.map((task) => ( // Render directly from taskData, no .filter() or .slice() needed
                  <div key={task._id} className={`p-3 transition-colors border rounded cursor-pointer hover:bg-gray-50 relative ${task.high_priority ? "border-red-500 bg-red-50" : "border-gray-200"}`} onClick={() => { handleTaskClick(task); setShowDropDown(false); }}>
                    <div className="flex flex-row justify-between items-center">
                      <div className="flex flex-col space-y-1">

                        <h3 className="font-medium max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg break-normal whitespace-normal leading-snug">
                          {task.title}
                        </h3>

                        <div className="flex  gap-5">
                          <p className="text-sm text-gray-500">[{task.taskId}]</p>
                          <p className="text-sm text-gray-500">
                            Word-Count: <span className="text-blue-500">{task.wordcount}</span>
                          </p>
                        </div>

                      </div>
                      <div className="flex flex-wrap gap-2 ">
                        <span className="px-3 py-2 text-xs text-green-700 bg-green-100 rounded-md">{new Date(task.soft_deadline).toLocaleDateString()}</span>
                        <span className={`px-3 py-2 text-xs rounded-md ${statusColors[task.status] || "bg-red-100 text-red-700"}`}>{task.status}</span>
                        {task.lastAssigneeName ? (
                          <span className="px-3 py-2 text-xs font-medium rounded-md bg-blue-100 text-blue-800">{task.lastAssigneeName}</span>
                        ) : (
                          <span className="px-3 py-2 text-xs font-medium rounded-md bg-orange-100 text-orange-800">Unassigned</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-gray-500 py-10"><p>No tasks found.</p><p>Try adjusting your search or filter.</p></div>
              )}
            </div>
            {/* --- END OF RENDER LOGIC MODIFICATION --- */}

            {/* --- PAGINATION UI UPDATED --- */}
            {totalPages > 1 && (
              <div className="flex justify-center items-center gap-4 p-4 border-t">
                <button className={`px-3 py-1 border rounded ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"}`} disabled={currentPage === 1} onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}>Previous</button>
                <span className="text-sm font-medium">Page {currentPage} of {totalPages}</span>
                <button className={`px-3 py-1 border rounded ${currentPage >= totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"}`} disabled={currentPage >= totalPages} onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}>Next</button>
              </div>
            )}
            {/* --- END OF PAGINATION UI UPDATE --- */}
          </div>

          {/* The entire right-side panel remains unchanged */}
          <div className="lg:w-1/3 sm:w-full w-full relative bg-white rounded-lg shadow-lg">
            {/* Header */}
            {selectedTask ? (
                           <div ref={printRef} className="p-4 border-b flex items-center justify-between">

                               <h2 className="text-xl font-semibold text-gray-800">{isTaskLogsVisible ? "Task Logs" : isUploadBriefVisible ? "Upload Brief" : isCommentModalOpen ? (commentType === "query" ? "Raise Query" : "Add Comment") : isUploadPageVisible ? "Upload Solution" : "Task Details"}</h2>


                <div className="flex space-x-2 relative">
                  {/* Always visible icons */}
                  <button className="p-2 text-gray-600 rounded-full hover:bg-gray-100" onClick={() => handleTaskClick(selectedTask)}>
                    <FaInfo className="w-5 h-5" />
                  </button>
                  <button className="p-2 text-gray-600 rounded-full hover:bg-gray-100" onClick={handleUpload}>
                    <FaUpload className="w-5 h-5" />
                  </button>
                  <button className="p-2 text-gray-600 rounded-full hover:bg-gray-100" onClick={handleUploadBrief}>
                    <FaFileUpload className="w-5 h-5" />
                  </button>

                  {/* Three dots menu */}
                  <button
                    ref={dropdownRef}
                    className="p-2 text-gray-600 rounded-full hover:bg-gray-200 transition"
                    onClick={() => setShowDropDown(!showDropDown)}
                  >
                    <FiMoreVertical className="w-5 h-5" />
                  </button>

                  {/* Dropdown menu */}
                  {showDropDown && (
                    <div
                      ref={dropdownRef}
                      className="absolute right-0 mt-2 w-44 bg-white shadow-lg rounded-xl py-2 z-10 border border-gray-200"

                    >
                      {(permissions.includes("SeeLogs") || role === 'superadmin' || role === 'admin') && (
                        <button
                          className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition rounded-t-xl"
                          onClick={() => { handleOpenTaskLogs(); setShowDropDown(false); }}
                        >
                          <MdOutlineAccountTree className="w-5 h-5 text-gray-600" />
                          <span className="text-sm font-medium">Task Logs</span>
                        </button>
                      )}

                      <button
                        className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
                        onClick={() => { handlePrint(); setShowDropDown(false); }}
                      >
                        <FiPrinter className="w-5 h-5 text-gray-600" />
                        <span className="text-sm font-medium">Print</span>
                      </button>

                      {(permissions.includes("SeeComments") || role === 'superadmin' || role === 'admin') && (
                        <button
                          className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition"
                          onClick={() => {
                            handleCommentModal("comment");
                            setShowDropDown(false);
                          }}
                        >
                          <FaCommentDots className="w-5 h-5 text-gray-600" />
                          <span className="text-sm font-medium">Add Comment</span>
                        </button>
                      )}

                      {(permissions.includes("SeeQuery") || role === 'superadmin' || role === 'admin') && (
                        <button
                          className="flex items-center gap-3 w-full px-4 py-3 text-gray-700 hover:bg-gray-100 transition rounded-b-xl"
                          onClick={() => {
                            handleCommentModal("query");
                            setShowDropDown(false);
                          }}
                        >
                          <FaQuestionCircle className="w-5 h-5 text-gray-600" />
                          <span className="text-sm font-medium">Raise Query</span>
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="p-4 border-b flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-800">Task Details</h2>
              </div>
            )}

            {/* Content */}
            <div className="p-4 w-full h-[85%] flex flex-col items-center ">
              {isTaskLogsVisible ? (
                <div ref={printRef} className="w-full p-6 bg-white rounded-lg">
                  <h2 className="text-lg font-semibold text-gray-800 text-center">
                    {selectedTask?.title || "Untitled Task"}
                  </h2>

                  <div className="mt-2 space-y-2 text-gray-600">
                    <p>
                      <span className="font-medium">Status:</span>
                      {"  "}
                      <span
                        className={`px-2 py-1 text-sm font-medium rounded-md ${statusColors[selectedTask?.status] ||
                          "bg-red-100 text-red-700"
                          }`}
                      >
                        {selectedTask?.status || "Unknown"}
                      </span>
                    </p>
                    <div className="mt-4">
                      <h3 className="font-medium text-gray-700">Logs:</h3>
                      <div className="bg-gray-100 p-3 rounded-md text-sm text-gray-700">
                        {selectedTask?.iterations &&
                          selectedTask?.iterations.length > 0 ? (
                          <ul className="list-disc list-inside space-y-1">
                            {selectedTask.iterations.map((log, index) => (
                              <React.Fragment key={index}>
                                <li>
                                  {names[log.assigned_by] || "N/A"}{" "}
                                  <span className="font-medium text-gray-800">
                                    {log.status === "Running"
                                      ? "Assigned to"
                                      : log.status}
                                  </span>{" "}
                                  {names[log.assigned_to] || "N/A"}{" "}
                                  <span className="font-medium text-gray-800">
                                    {`(${new Date(log.createdAt).toLocaleString()})`}
                                  </span>
                                </li>
                                {log.status === "Running" && (
                                  <li>
                                    {names[log.assigned_to] || "N/A"}{" "}
                                    <span className="font-medium text-gray-800">
                                      is working on.
                                    </span>
                                  </li>
                                )}
                              </React.Fragment>
                            ))}
                          </ul>
                        ) : (
                          <p>No logs available.</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-center mt-6">
                    <button
                      className="px-6 py-2 bg-[#3758ff] hover:bg-blue-900 text-white font-semibold rounded-md shadow transition"
                      onClick={handleCloseTaskLogs}
                    >
                      Close Logs
                    </button>
                  </div>
                </div>
              ) : isUploadBriefVisible ? (
                                <div ref={printRef} className="w-full h-[100%] space-y-4 p-4 bg-white shadow rounded-lg flex flex-col">

                 {(permissions.includes("AddBrief") || (role === 'superadmin' || role === 'admin')) && (
                    <div className="border-b pb-4">
                       <h3 className="text-lg font-medium text-gray-800 mb-2">Upload New Brief</h3>
                      <input type="file" id="file" multiple onChange={handleFileChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none text-sm"/>
                      <div className="mt-4">
                        <button className="mr-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" onClick={handleBriefSubmit} disabled={isUploading}>{isUploading ? "Uploading..." : "Submit Brief"}</button>
                        <button className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition" onClick={handleCloseUploadPage}>Close</button>
                      </div>
                    </div>
                  )}

                  {/* Display uploaded brief */}
                  {(permissions.includes("SeeBrief") || (role === 'superadmin' || role === 'admin')) && (
                    <div className="flex-1 overflow-y-auto scrollbar-thin">
                      <h3 className="text-lg font-medium text-gray-800">Uploaded Briefs</h3>
                      {brief && brief.length > 0 ? (
                        <div className="space-y-4 mt-2">
                          {brief.map((item, index) => (
                            <div key={index} className="text-sm text-gray-600 border-b pb-3 flex flex-col gap-2">
                              <p><strong>Uploaded By:</strong> {item.employeeName || "Unknown"}</p>
                              <div className="flex items-center gap-3 flex-1 min-w-0">
                                {item.uploadPath && item.name && (
                                  <>
                                    {["jpg", "jpeg", "png", "gif"].includes(item.name.split(".").pop().toLowerCase()) ? <FaFileImage className="text-blue-500 cursor-pointer flex-shrink-0" size={20} onClick={() => window.open(item.uploadPath, "_blank")} /> : item.name.split(".").pop().toLowerCase() === "pdf" ? <FaFilePdf className="text-red-500 cursor-pointer flex-shrink-0" size={20} onClick={() => window.open(item.uploadPath, "_blank")} /> : <FaFileAlt className="text-gray-500 cursor-pointer flex-shrink-0" size={20} onClick={() => window.open(item.uploadPath, "_blank")} />}
                                    <span className="text-sm text-gray-700 truncate cursor-pointer hover:underline" onClick={() => window.open(item.uploadPath, "_blank")} title={item.name}>{item.name}</span>
                                  </>
                                )}
                              </div>
                              <p><strong>Timestamp:</strong> {new Date(item.updatedAt).toLocaleString()}</p>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center text-gray-500 py-6"><p>No briefs have been uploaded yet.</p></div>
                      )}
                    </div>
                  )}


                </div>
              ) : isCommentModalOpen && selectedTask?._id ? (

                <CommentModal
                  isOpen={isCommentModalOpen}
                  taskId={selectedTask?._id}
                  type={commentType} // Pass the type to differentiate
                  onClose={() => setIsCommentModalOpen(false)}
                />

              ) : isUploadPageVisible ? (
                                <div ref={printRef} className="w-full h-[100%] space-y-4 p-4 bg-white shadow rounded-lg flex flex-col">

                 {(permissions.includes("AddSolutions") || (role === 'superadmin' || role === 'admin')) && (
                     <div className="border-b pb-4">
                      <h3 className="text-lg font-medium text-gray-800 mb-2">Upload New Solution</h3>
                      <input type="file" id="file" multiple onChange={handleFileChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none text-sm"/>
                      {uploadError && <div className="text-red-500 text-sm mt-2">{uploadError}</div>}
                      <div className="mt-4">
                        <button className="mr-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" onClick={handleSubmit} disabled={isUploading}>{isUploading ? "Uploading..." : "Submit Solution"}</button>
                        <button className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition" onClick={handleCloseUploadPage}>Close</button>
                      </div>
                    </div>
                  )}

                                    {(permissions.includes("SeeSolutions") || (role === 'superadmin' || role === 'admin')) && (
                    <div className="flex-1 overflow-y-auto scrollbar-thin">
                      <h3 className="text-lg font-medium text-gray-800">Uploaded Solutions</h3>
                      {solution && solution.length > 0 ? (
                        <div className="space-y-4 mt-2">
                          {solution.map((item, index) => (
                            <div key={index} className="text-sm text-gray-600 border-b pb-3 flex flex-col gap-2">
                              <p><strong>Uploaded By:</strong> {names[item.employeeId] || "Unknown"}</p>
                              <div className="space-y-2">
                                <p className="font-medium">Files:</p>
                                <ul className="space-y-2">
                                  {item.files.map((file, fileIndex) => {
                                    const fileName = file.split("/").pop();
                                    const handleOpenFile = () => window.open(file, "_blank");
                                    return (
                                      <li key={fileIndex} className="flex items-center gap-3 flex-1 min-w-0">
                                        {fileName.match(/\.(jpg|jpeg|png|gif)$/i) ? <FaFileImage className="text-blue-500 cursor-pointer flex-shrink-0" size={20} onClick={handleOpenFile} /> : fileName.endsWith('.pdf') ? <FaFilePdf className="text-red-500 cursor-pointer flex-shrink-0" size={20} onClick={handleOpenFile} /> : <FaFileAlt className="text-gray-500 cursor-pointer flex-shrink-0" size={20} onClick={handleOpenFile} />}
                                        <span className="text-sm text-gray-700 truncate cursor-pointer hover:underline" onClick={handleOpenFile} title={fileName}>{fileName}</span>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                              <p><strong>Timestamp:</strong> {new Date(item.timestamp).toLocaleString()}</p>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-center text-gray-500 py-6"><p>No solutions have been uploaded yet.</p></div>
                      )}
                    </div>
                  )}
                </div>
              ) : selectedTask ? (
                <div
                  ref={printRef}
                  className="w-full max-h-[75vh] overflow-y-auto space-y-6 p-4 bg-white shadow rounded-lg scrollbar-thin"

                >
                  {/* Task Details Section */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <div className="h-14 w-14 rounded-full bg-blue-100 flex items-center justify-center">
                        <span className="text-blue-600 text-xl font-semibold uppercase">
                          {selectedTask?.title?.[0] || "T"}
                        </span>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-800">
                          {selectedTask?.title}
                        </h3>
                        <p className="text-sm text-gray-500">
                          Task ID: {selectedTask?.taskId}
                        </p>
                      </div>
                    </div>

                    {/* Three-dot Menu */}
                    <div className="">
                      <button className="p-0 pb-6 text-gray-600 rounded-full">
                        <FiMoreVertical
                          className="w-4 h-4"
                          onClick={handleToggleDropdown}
                        />
                      </button>
                      {isDropDownOpen && (
                        <div
                          ref={dropdownRef}
                          className="absolute right-12 top-1/4 w-48 bg-white border rounded-lg shadow-lg z-10"
                        >
                          {(permissions.includes("AssignTask") || (role === 'superadmin' || role === 'admin')) && <button
                            className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
                            onClick={() => setIsAssinTaskModalOpen(true)}
                          >
                            Assign
                          </button>}
                          {(permissions.includes("SeeTransaction") || (role === 'superadmin' || role === 'admin')) && <button className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
                            onClick={() => setIsPaymentButtonClicked()}>
                            Payment
                          </button>}
                          {(permissions.includes("CompleteTask") || (role === 'superadmin' || role === 'admin')) && <button
                            ref={dropdownRef}
                            className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
                            onClick={handleCompleteTask}
                          >
                            Complete
                          </button>}
                          {(permissions.includes("DeliverTask") || (role === 'superadmin' || role === 'admin')) && <button
                            className="block w-full px-4 py-2 text-left text-sm text-gray-800 hover:bg-gray-100"
                            onClick={handleDeliverTask}
                          >
                            Delivered
                          </button>}
                          {/* --- UPDATED: Conditional Action Buttons --- */}
                          <div className="border-t mt-2">
                            {(permissions.includes("UpdateTask") || (role === 'superadmin' || role === 'admin')) && <button
                              className="block w-full px-4 py-2 text-left text-sm text-blue-600 hover:bg-gray-100"
                              onClick={() => openTaskModal(selectedTask)}
                            >
                              Edit Task
                            </button>}

                            {/* Show Resume button if task is On Hold */}
                            {selectedTask?.status === 'On Hold' && (permissions.includes("resumeTask") || role === 'superadmin' || role === 'admin') && (
                              <button
                                className="block w-full px-4 py-2 text-left text-sm text-green-600 hover:bg-gray-100"
                                onClick={() => {
                                  handleResumeTask();
                                  setIsDropDownOpen(false);
                                }}
                              >
                                Resume Task
                              </button>
                            )}

                            {/* Show Hold and Cancel buttons if task is active (not On Hold or Cancelled) */}
                            {selectedTask?.status !== 'On Hold' && selectedTask?.status !== 'Cancelled' && (
                              <>
                                {(permissions.includes("holdTask") || role === 'superadmin' || role === 'admin') && (
                                  <button
                                    className="block w-full px-4 py-2 text-left text-sm text-yellow-600 hover:bg-gray-100"
                                    onClick={() => {
                                      setIsDropDownOpen(false);
                                      setIsHoldModalOpen(true);
                                    }}
                                  >
                                    Hold Task
                                  </button>
                                )}
                                {(permissions.includes("CancelTask") || role === 'superadmin' || role === 'admin') && (
                                  <button
                                    className="block w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100"
                                    onClick={() => {
                                      handleCancelTask();
                                      setIsDropDownOpen(false);
                                    }}
                                  >
                                    Cancel Task
                                  </button>
                                )}
                              </>
                            )}

                            {(permissions.includes("DeleteTask") || (role === 'superadmin' || role === 'admin')) && <button
                              className="block w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100"
                              onClick={() => handleDelete(selectedTask?._id)}
                            >
                              Delete Task
                            </button>}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Task Details Section */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {(permissions.includes("SeeClient") || (role === 'superadmin' || role === 'admin')) && <div>
                      <span className="text-sm font-medium text-gray-600">
                        Client:
                      </span>
                      <p className="text-gray-800">
                        {selectedTask?.clientName || "N/A"}
                      </p>
                    </div>}
                    <div>
                      <span className="text-sm font-medium text-gray-600">
                        Department:
                      </span>
                      <p className="text-gray-800">
                        {selectedTask?.departmentName || "N/A"}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">
                        Word Count:
                      </span>
                      <p className="text-gray-800">{selectedTask?.wordcount}</p>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">
                        Status:
                      </span>
                      <p
                        className={`font-medium ${selectedTask?.status === "Running"
                          ? "text-green-700"
                          : "text-red-700"
                          }`}
                      >
                        {selectedTask?.status}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">
                        Soft Deadline:
                      </span>
                      <p className="text-gray-800">
                        {new Date(
                          selectedTask?.soft_deadline
                        ).toLocaleDateString()}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-gray-600">
                        Hard Deadline:
                      </span>
                      <p className="text-gray-800">
                        {new Date(
                          selectedTask?.hard_deadline
                        ).toLocaleDateString()}
                      </p>
                    </div>
                  </div>

                  {/* Description */}
                  <div>
                    <span className="text-sm font-medium text-gray-600">
                      Description:
                    </span>
                    <p className="text-gray-800">{selectedTask?.description}</p>
                  </div>
                  <div className="mt-3 flex gap-3">
                    <button
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                      onClick={() => window.open(`/${role.toLowerCase()}/tasks/view/${selectedTask._id}`, '_blank')}
                    >
                      View Full Details
                    </button>

                    {(permissions.includes("Seelogs") || role === 'superadmin' || role === 'admin') && (() => {
                      const lastExtension = selectedTask?.extensionRequests?.slice(-1)[0];
                      if (!lastExtension) return (
                        <button
                          className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                          onClick={() => setIsExtensionModalOpen(true)}
                        >
                          Apply Extension
                        </button>
                      );

                      return (
                        <span
                          className={`font-semibold px-3 py-1 rounded ${lastExtension.status === "Pending" ? "text-yellow-600" :
                            lastExtension.status === "Approved" ? "text-green-600" :
                              "text-red-600"
                            }`}
                        >
                          Extension {lastExtension.status}
                        </span>
                      );
                    })()}


                  </div>

                </div>
              ) : (
                <div className="text-center text-gray-500">
                  <p>No Task Selected</p>
                  <p>Select a task to view details</p>
                </div>
              )}
            </div>
          </div>
        </main >
      </div >

      {/* All modals remain unchanged */}
      {isAssinTaskModalOpen && (
        <AssignTask
          taskId={selectedTask?._id}
          closeAssignTaskModal={closeAssignTaskModal}
          setIsAssinTaskModalOpen={setIsAssinTaskModalOpen}
          fetchTaskData={fetchTaskData}
          employees={employees}
        />
      )}

      {
        isAddTaskModalOpen && (
          <AddTask
            closeAddTaskModal={closeAddTaskModal}
            setIsAddTaskModalOpen={setIsAddTaskModalOpen}
            editingTask={editingTask}
            fetchTaskData={fetchTaskData}
          />
        )
      }
      {isExtensionModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-lg">
            <h2 className="text-xl font-semibold mb-4">Request Extension</h2>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Soft Deadline</label>
              <input
                type="datetime-local"
                className="w-full px-3 py-2 border rounded"
                value={newSoftDeadline}
                onChange={(e) => setNewSoftDeadline(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Hard Deadline</label>
              <input
                type="datetime-local"
                className="w-full px-3 py-2 border rounded"
                value={newHardDeadline}
                onChange={(e) => setNewHardDeadline(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Reason</label>
              <textarea
                className="w-full px-3 py-2 border rounded"
                rows={3}
                value={extensionReason}
                onChange={(e) => setExtensionReason(e.target.value)}
              />
            </div>

            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setIsExtensionModalOpen(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={handleApplyExtension}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {isHoldModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Hold Task</h2>
            <textarea
              rows={4}
              value={holdReason}
              onChange={(e) => setHoldReason(e.target.value)}
              className="w-full border border-gray-300 rounded p-2 mb-4 focus:outline-none focus:ring"
              placeholder="Enter reason for holding this task"
            />
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setIsHoldModalOpen(false)}
                className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
              >
                Cancel
              </button>
              <button
                onClick={handleHoldTask}
                className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
              >
                Confirm Hold
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default AllTasks;